(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports={
  "continent": [{
  "id": "1",
  "name": "Asia"
}, {
  "id": "2",
  "name": "Europe"
}, {
  "id": "3",
  "name": "North America"
}, {
  "id": "4",
  "name": "South America"
}, {
  "id": "5",
  "name": "Africa"
}, {
  "id": "6",
  "name": "Oceania"
}],
  "country": [{
  "image": "afuhan.gif",
  "name": "Afghanistan",
  "id": "AF",
  "cid": "1",
  "currency": "AFN"
}, {
  "image": "arbny.gif",
  "name": "Albania",
  "id": "AL",
  "cid": "2",
  "currency": "ALL"
}, {
  "image": "arjly.gif",
  "name": "Algeria",
  "id": "DZ",
  "cid": "5",
  "currency": "DZD"
}, {
  "image": "andaor.gif",
  "name": "Andorra",
  "id": "AD",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "angla.gif",
  "name": "Angola",
  "id": "AO",
  "cid": "5",
  "currency": "AOA"
}, {
  "image": "bbd.gif",
  "name": "Antigua and Barbuda",
  "id": "AG",
  "cid": "3",
  "currency": "XCD"
}, {
  "image": "flg_argentina_sm.gif",
  "name": "Argentina",
  "id": "AR",
  "cid": "4",
  "currency": "ARS"
}, {
  "image": "yameiniya.gif",
  "name": "Armenia",
  "id": "AM",
  "cid": "1",
  "currency": "AMD"
}, {
  "image": "flg_australia_sm.gif",
  "name": "Australia",
  "id": "AU",
  "cid": "6",
  "currency": "AUD"
}, {
  "image": "flg_austria_sm.gif",
  "name": "Austria",
  "id": "AT",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "asaibaijiang.gif",
  "name": "Azerbaijan",
  "id": "AZ",
  "cid": "1",
  "currency": "AZN"
}, {
  "image": "bahama.gif",
  "name": "Bahamas",
  "id": "BS",
  "cid": "3",
  "currency": "BSD"
}, {
  "image": "balin.gif",
  "name": "Bahrain",
  "id": "BH",
  "cid": "1",
  "currency": "BHD"
}, {
  "image": "memgjiala.gif",
  "name": "Bangladesh",
  "id": "BD",
  "cid": "1",
  "currency": "BDT"
}, {
  "image": "babaduosi.gif",
  "name": "Barbados",
  "id": "BB",
  "cid": "3",
  "currency": "BBD"
}, {
  "image": "baie.gif",
  "name": "Belarus",
  "id": "BY",
  "cid": "2",
  "currency": "BYN"
}, {
  "image": "bilishi.gif",
  "name": "Belgium",
  "id": "BE",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "blz.gif",
  "name": "Belize",
  "id": "BZ",
  "cid": "3",
  "currency": "BZD"
}, {
  "image": "beinin.gif",
  "name": "Benin",
  "id": "BJ",
  "cid": "5",
  "currency": "XAF"
}, {
  "image": "budan.gif",
  "name": "Bhutan",
  "id": "BT",
  "cid": "1",
  "currency": "INR"
}, {
  "image": "flg_bolivia_sm.gif",
  "name": "Bolivia",
  "id": "BO",
  "cid": "4",
  "currency": "BOB"
},{"image": "flag_ba.gif","name": "Bosnia and Herzegovina","id": "BA","cid": "2","currency": "BAK"}
  ,  {
  "image": "bociwana.gif",
  "name": "Botswana",
  "id": "BW",
  "cid": "5",
  "currency": "BWP"
}, {
  "image": "flg_brazil_sm.gif",
  "name": "Brazil",
  "id": "BR",
  "cid": "4",
  "currency": "BRL"
}, {
  "image": "wenlai.gif",
  "name": "Brunei",
  "id": "BN",
  "cid": "1",
  "currency": "BND"
}, {
  "image": "baojly.gif",
  "name": "Bulgaria",
  "id": "BG",
  "cid": "2",
  "currency": "BGN"
}, {
  "image": "bjnfs.gif",
  "name": "Burkina",
  "id": "BF",
  "cid": "5",
  "currency": "BGN"
}, {
  "image": "bulongdi.gif",
  "name": "Burundi",
  "id": "BI",
  "cid": "5",
  "currency": "BIF"
}, {
  "image": "jianpuzai.gif",
  "name": "Cambodia",
  "id": "KH",
  "cid": "1",
  "currency": "KHR"
}, {
  "image": "kamailong.gif",
  "name": "Cameroon",
  "id": "CM",
  "cid": "5",
  "currency": "XAF"
}, {
  "image": "flg_canada_sm.gif",
  "name": "Canada",
  "id": "CA",
  "cid": "3",
  "currency": "CAD"
}, {
  "image": "fodej.gif",
  "name": "Cape Verde",
  "id": "CV",
  "cid": "5",
  "currency": "CVE"
}, {
  "image": "zhongfei.gif",
  "name": "Central African Republic",
  "id": "CF",
  "cid": "5",
  "currency": "XAF"
}, {
  "image": "zhade.gif",
  "name": "Chad",
  "id": "TD",
  "cid": "5",
  "currency": "XAF"
}, {
  "image": "flg_chile_sm.gif",
  "name": "Chile",
  "id": "CL",
  "cid": "4",
  "currency": "CLP"
}, {
  "image": "flg_china_sm.gif",
  "name": "China",
  "id": "CN",
  "cid": "1",
  "currency": "CNY"
}, {
  "image": "flg_colombia_sm.gif",
  "name": "Colombia",
  "id": "CO",
  "cid": "4",
  "currency": "COP"
}, {
  "image": "kemoluo.gif",
  "name": "Comoros",
  "id": "KM",
  "cid": "5",
  "currency": "USD"
}, {
  "image": "flg_costarica_sm.gif",
  "name": "Costa Rica",
  "id": "CR",
  "cid": "3",
  "currency": "CRC"
}, {
  "image": "kldy.gif",
  "name": "Croatia",
  "id": "HR",
  "cid": "2",
  "currency": "HRK"
}, {
  "image": "guba.gif",
  "name": "Cuba",
  "id": "CU",
  "cid": "3",
  "currency": "CUP"
}, {
  "image": "saipulusi.gif",
  "name": "Cyprus",
  "id": "CY",
  "cid": "1",
  "currency": "EUR"
}, {
  "image": "jieke.gif",
  "name": "Czech Republic",
  "id": "CZ",
  "cid": "2",
  "currency": "CZK"
}, {
  "image": "minzhugg.gif",
  "name": "Democratic Republic of the Congo",
  "id": "CD",
  "cid": "5",
  "currency": "XAF"
}, {
  "image": "danmai.gif",
  "name": "Denmark",
  "id": "DK",
  "cid": "2",
  "currency": "DKK"
}, {
  "image": "jibuti.gif",
  "name": "Djibouti",
  "id": "DJ",
  "cid": "5",
  "currency": "DJF"
}, {
  "image": "dmnike.gif",
  "name": "Dominica",
  "id": "DM",
  "cid": "3",
  "currency": "XCD"
}, {
  "image": "duominijia.gif",
  "name": "Dominican Republic",
  "id": "DO",
  "cid": "3",
  "currency": "DOP"
}, {
  "image": "egde.gif",
  "name": "Ecuador",
  "id": "EC",
  "cid": "4",
  "currency": "USD"
}, {
  "image": "aiji.gif",
  "name": "Egypt",
  "id": "EG",
  "cid": "5",
  "currency": "EGP"
}, {
  "image": "flg_elsavador_sm.gif",
  "name": "El Salvador",
  "id": "SV",
  "cid": "3",
  "currency": "USD"
}, {
  "image": "chdjny.gif",
  "name": "Equatorial Guinea",
  "id": "GQ",
  "cid": "5",
  "currency": "XAF"
}, {
  "image": "eltly.gif",
  "name": "Eritrea",
  "id": "ER",
  "cid": "5",
  "currency": "ERN"
}, {
  "image": "aishny.gif",
  "name": "Estonia",
  "id": "EE",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "aiseby.gif",
  "name": "Ethiopia",
  "id": "ET",
  "cid": "5",
  "currency": "ETB"
}, {
  "image": "feiji.gif",
  "name": "Fiji",
  "id": "FJ",
  "cid": "6",
  "currency": "FJD"
}, {
  "image": "fenlan.gif",
  "name": "Finland",
  "id": "FI",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "flg_france_sm.gif",
  "name": "France",
  "id": "FR",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "jiapeng.gif",
  "name": "Gabon",
  "id": "GA",
  "cid": "5",
  "currency": "XAF"
}, {
  "image": "gbya.gif",
  "name": "Gambia",
  "id": "GM",
  "cid": "5",
  "currency": "GMD"
}, {
  "image": "gelujiya.gif",
  "name": "Georgia",
  "id": "GE",
  "cid": "1",
  "currency": "GEL"
}, {
  "image": "flg_germany_sm.gif",
  "name": "Germany",
  "id": "DE",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "jiana.gif",
  "name": "Ghana",
  "id": "GH",
  "cid": "5",
  "currency": "GHS"
}, {
  "image": "xila.gif",
  "name": "Greece",
  "id": "GR",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "gelinnada.gif",
  "name": "Grenada",
  "id": "GD",
  "cid": "3",
  "currency": "XCD"
}, {
  "image": "flg_guetamala_sm.gif",
  "name": "Guatemala",
  "id": "GT",
  "cid": "3",
  "currency": "GTQ"
}, {
  "image": "jineiya.gif",
  "name": "Guinea",
  "id": "GN",
  "cid": "5",
  "currency": "GNF"
}, {
  "image": "bishao.gif",
  "name": "Guinea-Bissau",
  "id": "GW",
  "cid": "5",
  "currency": "XAF"
}, {
  "image": "guiyana.gif",
  "name": "Guyana",
  "id": "GY",
  "cid": "4",
  "currency": "GYD"
}, {
  "image": "haidi.gif",
  "name": "Haiti",
  "id": "HT",
  "cid": "3",
  "currency": "HTG"
}, {
  "image": "flg_honduras_sm.gif",
  "name": "Honduras",
  "id": "HN",
  "cid": "3",
  "currency": "HNL"
}, {
   "image": "hongkong.png",
   "name": "Hong Kong",
   "id": "HK",
   "cid": "1",
   "currency": "HKD"
  }, {
  "image": "xyl.gif",
  "name": "Hungary",
  "id": "HU",
  "cid": "2",
  "currency": "HUF"
}, {
  "image": "bingdao.gif",
  "name": "Iceland",
  "id": "IS",
  "cid": "2",
  "currency": "ISK"
}, {
  "image": "yindu.gif",
  "name": "India",
  "id": "IN",
  "cid": "1",
  "currency": "INR"
}, {
  "image": "yinni.gif",
  "name": "Indonesia",
  "id": "ID",
  "cid": "1",
  "currency": "IDR"
}, {
  "image": "yilang.gif",
  "name": "Iran",
  "id": "IR",
  "cid": "1",
  "currency": "IRR"
}, {
  "image": "yilake.gif",
  "name": "Iraq",
  "id": "IQ",
  "cid": "1",
  "currency": "IQD"
}, {
  "image": "airlan.gif",
  "name": "Ireland",
  "id": "IE",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "yiselie.gif",
  "name": "Israel",
  "id": "IL",
  "cid": "1",
  "currency": "ILS"
}, {
  "image": "ydl.gif",
  "name": "Italy",
  "id": "IT",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "ketediwa.gif",
  "name": "Ivory Coast",
  "id": "CI",
  "cid": "5",
  "currency": "USD"
}, {
  "image": "yamaijia.gif",
  "name": "Jamaica",
  "id": "JM",
  "cid": "3",
  "currency": "JMD"
}, {
  "image": "riben.gif",
  "name": "Japan",
  "id": "JP",
  "cid": "1",
  "currency": "JPY"
}, {
  "image": "yuedan.gif",
  "name": "Jordan",
  "id": "JO",
  "cid": "1",
  "currency": "JOD"
}, {
  "image": "hasakesitan.gif",
  "name": "Kazakhstan",
  "id": "KZ",
  "cid": "1",
  "currency": "KZT"
}, {
  "image": "keniya.gif",
  "name": "Kenya",
  "id": "KE",
  "cid": "5",
  "currency": "KES"
}, {
  "image": "jlbs.gif",
  "name": "Kiribati",
  "id": "KI",
  "cid": "6",
  "currency": "AUD"
},  {"image": "flag_ks.gif","name": "Kosovo","id": "KS","cid": "2","currency": "EUR"}
  , {
  "image": "keweite.gif",
  "name": "Kuwait",
  "id": "KW",
  "cid": "1",
  "currency": "KWD"
}, {
  "image": "jiererjisitan.gif",
  "name": "Kyrgyzstan",
  "id": "KG",
  "cid": "1",
  "currency": "KGS"
}, {
  "image": "laowo.gif",
  "name": "Laos",
  "id": "LA",
  "cid": "1",
  "currency": "LAK"
}, {
  "image": "latwy.gif",
  "name": "Latvia",
  "id": "LV",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "libaneng.gif",
  "name": "Lebanon",
  "id": "LB",
  "cid": "1",
  "currency": "LBP"
}, {
  "image": "laisuotuo.gif",
  "name": "Lesotho",
  "id": "LS",
  "cid": "5",
  "currency": "LSL"
}, {
  "image": "libiliya.gif",
  "name": "Liberia",
  "id": "LR",
  "cid": "5",
  "currency": "LRD"
}, {
  "image": "libia.gif",
  "name": "Libya",
  "id": "LY",
  "cid": "5",
  "currency": "LYD"
}, {
  "image": "liezdsd.gif",
  "name": "Liechtenstein",
  "id": "LI",
  "cid": "2",
  "currency": "USD"
}, {
  "image": "litaow.gif",
  "name": "Lithuania",
  "id": "LT",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "lusbao.gif",
  "name": "Luxembourg",
  "id": "LU",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "macao.png",
  "name": "Macao",
  "id": "MO",
  "cid": "1",
  "currency": "MOP"
}, {
  "image": "maqidun.gif",
  "name": "Macedonia",
  "id": "MK",
  "cid": "2",
  "currency": "MKD"
}, {
  "image": "mdjsj.gif",
  "name": "Madagascar",
  "id": "MG",
  "cid": "5",
  "currency": "MGA"
}, {
  "image": "malawei.gif",
  "name": "Malawi",
  "id": "MW",
  "cid": "5",
  "currency": "MWK"
}, {
  "image": "malaixiya.gif",
  "name": "Malaysia",
  "id": "MY",
  "cid": "1",
  "currency": "MYR"
}, {
  "image": "maerdaifu.gif",
  "name": "Maldives",
  "id": "MV",
  "cid": "1",
  "currency": "MVR"
}, {
  "image": "mali.gif",
  "name": "Mali",
  "id": "ML",
  "cid": "5",
  "currency": "XAF"
}, {
  "image": "mart.gif",
  "name": "Malta",
  "id": "MT",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "flg_mashr.gif",
  "name": "Marshall islands",
  "id": "MH",
  "cid": "6",
  "currency": "USD"
}, {
  "image": "mltny.gif",
  "name": "Mauritania",
  "id": "MR",
  "cid": "5",
  "currency": "MRU"
}, {
  "image": "mlqs.gif",
  "name": "Mauritius",
  "id": "MU",
  "cid": "5",
  "currency": "MUR"
}, {
  "image": "flg_mexico_sm.gif",
  "name": "Mexico",
  "id": "MX",
  "cid": "3",
  "currency": "MXN"
}, {
  "image": "mklnxy.gif",
  "name": "Micronesia",
  "id": "FM",
  "cid": "6",
  "currency": "USD"
}, {
  "image": "mordw.gif",
  "name": "Moldova",
  "id": "MD",
  "cid": "2",
  "currency": "MDL"
}, {
  "image": "monage.gif",
  "name": "Monaco",
  "id": "MC",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "menggu.gif",
  "name": "Mongolia",
  "id": "MN",
  "cid": "1",
  "currency": "MNT"
},{"image": "flag_me.gif","name": "Montenegro","id": "ME","cid": "2","currency": "EUR"}
  ,  {
  "image": "molog.gif",
  "name": "Morocco",
  "id": "MA",
  "cid": "5",
  "currency": "MAD"
}, {
  "image": "msbk.gif",
  "name": "Mozambique",
  "id": "MZ",
  "cid": "5",
  "currency": "MZN"
}, {
  "image": "miandian.gif",
  "name": "Myanmar",
  "id": "MM",
  "cid": "1",
  "currency": "USD"
}, {
  "image": "nmby.gif",
  "name": "Namibia",
  "id": "NA",
  "cid": "5",
  "currency": "NAD"
}, {
  "image": "naolu.gif",
  "name": "Nauru",
  "id": "NR",
  "cid": "6",
  "currency": "AUD"
}, {
  "image": "niboer.gif",
  "name": "Nepal",
  "id": "NP",
  "cid": "1",
  "currency": "NPR"
}, {
  "image": "flg_netherlands_sm.gif",
  "name": "Netherlands",
  "id": "NL",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "flg_newzealand_sm.gif",
  "name": "New Zealand",
  "id": "NZ",
  "cid": "6",
  "currency": "NZD"
}, {
  "image": "flg_nicaragua_sm.gif",
  "name": "Nicaragua",
  "id": "NI",
  "cid": "3",
  "currency": "NIO"
}, {
  "image": "nirir.gif",
  "name": "Niger",
  "id": "NE",
  "cid": "5",
  "currency": "XAF"
}, {
  "image": "niriliya.gif",
  "name": "Nigeria",
  "id": "NG",
  "cid": "5",
  "currency": "NGN"
}, {
  "image": "chaoxian.gif",
  "name": "North Korea",
  "id": "KP",
  "cid": "1",
  "currency": "KPW"
}, {
  "image": "nuowei.gif",
  "name": "Norway",
  "id": "NO",
  "cid": "2",
  "currency": "NOK"
}, {
  "image": "aman.gif",
  "name": "Oman",
  "id": "OM",
  "cid": "1",
  "currency": "OMR"
}, {
  "image": "bajisitan.gif",
  "name": "Pakistan",
  "id": "PK",
  "cid": "1",
  "currency": "PKR"
}, {
  "image": "palao.gif",
  "name": "Palau",
  "id": "PW",
  "cid": "6",
  "currency": "USD"
}, {
  "image": "balesitan.gif",
  "name": "Palestinian Territory",
  "id": "PS",
  "cid": "1",
  "currency": "USD"
}, {
  "image": "flg_panama_sm.gif",
  "name": "Panama",
  "id": "PA",
  "cid": "3",
  "currency": "PAB"
}, {
  "image": "baxi.gif",
  "name": "Papua New Guinea",
  "id": "PG",
  "cid": "6",
  "currency": "PGK"
}, {
  "image": "balagui.gif",
  "name": "Paraguay",
  "id": "PY",
  "cid": "4",
  "currency": "PYG"
}, {
  "image": "flg_peru_sm.gif",
  "name": "Peru",
  "id": "PE",
  "cid": "4",
  "currency": "PEN"
}, {
  "image": "feilubing.gif",
  "name": "Philippines",
  "id": "PH",
  "cid": "1",
  "currency": "PHP"
}, {
  "image": "bolan.gif",
  "name": "Poland",
  "id": "PL",
  "cid": "2",
  "currency": "PLN"
}, {
  "image": "flg_portugal_sm.gif",
  "name": "Portugal",
  "id": "PT",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "kataer.gif",
  "name": "Qatar",
  "id": "QA",
  "cid": "1",
  "currency": "QAR"
}, {
  "image": "gangguo.gif",
  "name": "Republic of the Congo",
  "id": "CG",
  "cid": "5",
  "currency": "USD"
}, {
  "image": "flg_romania_sm.gif",
  "name": "Romania",
  "id": "RO",
  "cid": "2",
  "currency": "RON"
}, {
  "image": "eluosi.gif",
  "name": "Russia",
  "id": "RU",
  "cid": "2",
  "currency": "RUB"
}, {
  "image": "luwangda.gif",
  "name": "Rwanda",
  "id": "RW",
  "cid": "5",
  "currency": "RWF"
}, {
  "image": "sjchnws.gif",
  "name": "Saint Kitts and Nevis",
  "id": "KN",
  "cid": "3",
  "currency": "XCD"
}, {
  "image": "slxy.gif",
  "name": "Saint Lucia",
  "id": "LC",
  "cid": "3",
  "currency": "XCD"
}, {
  "image": "swensente.gif",
  "name": "Saint Vincent and the Grenadines",
  "id": "VC",
  "cid": "3",
  "currency": "USD"
}, {
  "image": "samoya.gif",
  "name": "Samoa",
  "id": "WS",
  "cid": "6",
  "currency": "WST"
}, {
  "image": "sanmalino.gif",
  "name": "San Marino",
  "id": "SM",
  "cid": "2",
  "currency": "USD"
}, {
  "image": "sdmhplxb.gif",
  "name": "Sao Tome and Principe",
  "id": "ST",
  "cid": "5",
  "currency": "STN"
}, {
  "image": "shate.gif",
  "name": "Saudi Arabia",
  "id": "SA",
  "cid": "1",
  "currency": "SAR"
}, {
  "image": "snjer.gif",
  "name": "Senegal",
  "id": "SN",
  "cid": "5",
  "currency": "XAF"
},{"image": "flag_rs.gif","name": "Serbia","id": "RS","cid": "2","currency": "RSD"}, {
  "image": "saisher.gif",
  "name": "Seychelles",
  "id": "SC",
  "cid": "5",
  "currency": "SCR"
}, {
  "image": "sllang.gif",
  "name": "Sierra Leone",
  "id": "SL",
  "cid": "5",
  "currency": "SLL"
}, {
  "image": "xinjiapo.gif",
  "name": "Singapore",
  "id": "SG",
  "cid": "1",
  "currency": "SGD"
}, {
  "image": "slfk.gif",
  "name": "Slovakia",
  "id": "SK",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "slwny.gif",
  "name": "Slovenia",
  "id": "SI",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "suoluomen.gif",
  "name": "Solomon Islands",
  "id": "SB",
  "cid": "6",
  "currency": "SBD"
}, {
  "image": "suomali.gif",
  "name": "Somalia",
  "id": "SO",
  "cid": "5",
  "currency": "SOS"
}, {
  "image": "nanfei.gif",
  "name": "South Africa",
  "id": "ZA",
  "cid": "5",
  "currency": "ZAR"
}, {
  "image": "hanguo.gif",
  "name": "South Korea",
  "id": "KR",
  "cid": "1",
  "currency": "KRW"
}, {
  "image": "flg_spain_sm.gif",
  "name": "Spain",
  "id": "ES",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "sililanka.gif",
  "name": "Sri Lanka",
  "id": "LK",
  "cid": "1",
  "currency": "LKR"
}, {
  "image": "sudan.gif",
  "name": "Sudan",
  "id": "SD",
  "cid": "5",
  "currency": "SDG"
}, {
  "image": "sulinan.gif",
  "name": "Suriname",
  "id": "SR",
  "cid": "4",
  "currency": "SRD"
}, {
  "image": "swshlan.gif",
  "name": "Swaziland",
  "id": "SZ",
  "cid": "5",
  "currency": "SZL"
}, {
  "image": "ruidian.gif",
  "name": "Sweden",
  "id": "SE",
  "cid": "2",
  "currency": "SEK"
}, {
  "image": "ruishi.gif",
  "name": "Switzerland",
  "id": "CH",
  "cid": "2",
  "currency": "CHF"
}, {
  "image": "xuliya.gif",
  "name": "Syria",
  "id": "SY",
  "cid": "1",
  "currency": "SYP"
}, {
  "image": "taiwan.png",
  "name": "Taiwan",
  "id": "TW",
  "cid": "1",
  "currency": "TWD"
}, {
  "image": "tajikesitan.gif",
  "name": "Tajikistan",
  "id": "TJ",
  "cid": "1",
  "currency": "TJS"
}, {
  "image": "tsny.gif",
  "name": "Tanzania",
  "id": "TZ",
  "cid": "5",
  "currency": "TZS"
}, {
  "image": "taiguo.gif",
  "name": "Thailand",
  "id": "TH",
  "cid": "1",
  "currency": "THB"
}, {
  "image": "duoge.gif",
  "name": "Togo",
  "id": "TG",
  "cid": "5",
  "currency": "XAF"
}, {
  "image": "tangjia.gif",
  "name": "Tonga",
  "id": "TO",
  "cid": "6",
  "currency": "TOP"
}, {
  "image": "dbg.gif",
  "name": "Trinidad and Tobago",
  "id": "TT",
  "cid": "3",
  "currency": "TTD"
}, {
  "image": "tunis.gif",
  "name": "Tunisia",
  "id": "TN",
  "cid": "5",
  "currency": "TND"
}, {
  "image": "tuerqi.gif",
  "name": "Turkey",
  "id": "TR",
  "cid": "1",
  "currency": "TRY"
}, {
  "image": "tukumansitan.gif",
  "name": "Turkmenistan",
  "id": "TM",
  "cid": "1",
  "currency": "TMT"
}, {
  "image": "tuwalu.gif",
  "name": "Tuvalu",
  "id": "TV",
  "cid": "6",
  "currency": "AUD"
}, {
  "image": "wgd.gif",
  "name": "Uganda",
  "id": "UG",
  "cid": "5",
  "currency": "UGX"
}, {
  "image": "wukelan.gif",
  "name": "Ukraine",
  "id": "UA",
  "cid": "2",
  "currency": "UAH"
}, {
  "image": "alianqiu.gif",
  "name": "United Arab Emirates",
  "id": "AE",
  "cid": "1",
  "currency": "DH"
}, {
  "image":"flg_uk_sm.gif",
  "name":"United Kingdom",
  "id":"GB",
  "cid":"2",
  "currency": "GBP"
}, {
  "image":"flg_usa_sm.gif",
  "name":"United States",
  "id":"US",
  "cid":"3",
  "currency": "USD"
}, {
  "image": "flg_uruguay_sm.gif",
  "name": "Uruguay",
  "id": "UY",
  "cid": "4",
  "currency": "UYU"
}, {
  "image": "wuzibieke.gif",
  "name": "Uzbekistan",
  "id": "UZ",
  "cid": "1",
  "currency": "UZS"
}, {
  "image": "wnat.gif",
  "name": "Vanuatu",
  "id": "VU",
  "cid": "6",
  "currency": "VUV"
}, {
  "image": "fandigang.gif",
  "name": "Vatican",
  "id": "VA",
  "cid": "2",
  "currency": "EUR"
}, {
  "image": "flg_venezuela_sm.gif",
  "name": "Venezuela",
  "id": "VE",
  "cid": "4",
  "currency": "VEF"
}, {
  "image": "yuenan.gif",
  "name": "Vietnam",
  "id": "VN",
  "cid": "1",
  "currency": "VND"
}, {
  "image": "yemen.gif",
  "name": "Yemen",
  "id": "YE",
  "cid": "1",
  "currency": "YER"
}, {
  "image": "zanbiya.gif",
  "name": "Zambia",
  "id": "ZM",
  "cid": "5",
  "currency": "ZMW"
}, {
  "image": "jbbw.gif",
  "name": "Zimbabwe",
  "id": "ZW",
  "cid": "5",
  "currency": "ZWL"
}],
  "currency": [{
  "key": "AFN",
  "value": "Af",
  "defaultValue": "AFN_Af"
}, {
  "key": "ALL",
  "value": "L",
  "defaultValue": "ALL_L"
}, {
  "key": "DZD",
  "value": "د.ج",
  "defaultValue": "DZD_د.ج"
}, {
  "key": "EUR",
  "value": "€",
  "defaultValue": "EUR_€"
}, {
  "key": "AOA",
  "value": "Kz",
  "defaultValue": "AOA_Kz"
}, {
  "key": "XCD",
  "value": "$",
  "defaultValue": "XCD_$"
}, {
  "key": "ARS",
  "value": "$",
  "defaultValue": "ARS_$"
}, {
  "key": "AMD",
  "value": "Դ",
  "defaultValue": "AMD_Դ"
}, {
  "key": "AUD",
  "value": "$",
  "defaultValue": "AUD_$"
}, {
  "key": "AZN",
  "value": "ман",
  "defaultValue": "AZN_ман"
}, {
  "key": "BSD",
  "value": "$",
  "defaultValue": "BSD_$"
}, {
  "key": "BHD",
  "value": "ب.د",
  "defaultValue": "BHD_ب.د"
}, {
  "key": "BDT",
  "value": "৳",
  "defaultValue": "BDT_৳"
}, {
  "key": "BBD",
  "value": "$",
  "defaultValue": "BBD_$"
}, {
  "key": "BYN",
  "value": "Br",
  "defaultValue": "BYN_Br"
}, {
  "key": "BZD",
  "value": "$",
  "defaultValue": "BZD_$"
}, {
  "key": "XAF",
  "value": "₣",
  "defaultValue": "XAF_₣"
}, {
  "key": "INR",
  "value": "₹",
  "defaultValue": "INR_₹"
}, {
  "key": "BOB",
  "value": "Bs.",
  "defaultValue": "BOB_Bs."
}, {
  "key": "BWP",
  "value": "P",
  "defaultValue": "BWP_P"
}, {
  "key": "BRL",
  "value": "R$",
  "defaultValue": "BRL_R$"
}, {
  "key": "BND",
  "value": "$",
  "defaultValue": "BND_$"
}, {
  "key": "BGN",
  "value": "лв",
  "defaultValue": "BGN_лв"
}, {
  "key": "BIF",
  "value": "₣",
  "defaultValue": "BIF_₣"
}, {
  "key": "KHR",
  "value": "៛",
  "defaultValue": "KHR_៛"
}, {
  "key": "CAD",
  "value": "$",
  "defaultValue": "CAD_$"
}, {
  "key": "CVE",
  "value": "$",
  "defaultValue": "CVE_$"
}, {
  "key": "CLP",
  "value": "$",
  "defaultValue": "CLP_$"
}, {
  "key": "CNY",
  "value": "¥",
  "defaultValue": "CNY_¥"
}, {
  "key": "COP",
  "value": "$",
  "defaultValue": "COP_$"
}, {
  "key": "CRC",
  "value": "₡",
  "defaultValue": "CRC_₡"
}, {
  "key": "HRK",
  "value": "Kn",
  "defaultValue": "HRK_Kn"
}, {
  "key": "CUP",
  "value": "$",
  "defaultValue": "CUP_$"
}, {
  "key": "CZK",
  "value": "Kč",
  "defaultValue": "CZK_Kč"
}, {
  "key": "DKK",
  "value": "kr",
  "defaultValue": "DKK_kr"
}, {
  "key": "DJF",
  "value": "₣",
  "defaultValue": "DJF_₣"
}, {
  "key": "DOP",
  "value": "$",
  "defaultValue": "DOP_$"
}, {
  "key": "EGP",
  "value": "£",
  "defaultValue": "EGP_£"
}, {
  "key": "ERN",
  "value": "Nfk",
  "defaultValue": "ERN_Nfk"
}, {
  "key": "ETB",
  "value": "$",
  "defaultValue": "ETB_$"
}, {
  "key": "FJD",
  "value": "$",
  "defaultValue": "FJD_$"
}, {
  "key": "GBP",
  "value": "￡",
  "defaultValue": "GBP_￡"
}, {
  "key": "GMD",
  "value": "D",
  "defaultValue": "GMD_D"
}, {
  "key": "GEL",
  "value": "ლ",
  "defaultValue": "GEL_ლ"
}, {
  "key": "GHS",
  "value": "₵",
  "defaultValue": "GHS_₵"
}, {
  "key": "GTQ",
  "value": "Q",
  "defaultValue": "GTQ_Q"
}, {
  "key": "GNF",
  "value": "₣",
  "defaultValue": "GNF_₣"
}, {
  "key": "GYD",
  "value": "$",
  "defaultValue": "GYD_$"
}, {
  "key": "HTG",
  "value": "G",
  "defaultValue": "HTG_G"
}, {
  "key": "HNL",
  "value": "L",
  "defaultValue": "HNL_L"
}, {
  "key": "HUF",
  "value": "Ft",
  "defaultValue": "HUF_Ft"
}, {
  "key": "ISK",
  "value": "Kr",
  "defaultValue": "ISK_Kr"
}, {
  "key": "IDR",
  "value": "Rp",
  "defaultValue": "IDR_Rp"
}, {
  "key": "IRR",
  "value": "﷼",
  "defaultValue": "IRR_﷼"
}, {
  "key": "IQD",
  "value": "ع.د",
  "defaultValue": "IQD_ع.د"
}, {
  "key": "ILS",
  "value": "₪",
  "defaultValue": "ILS_₪"
}, {
  "key": "JMD",
  "value": "$",
  "defaultValue": "JMD_$"
}, {
  "key": "JPY",
  "value": "¥",
  "defaultValue": "JPY_¥"
}, {
  "key": "JOD",
  "value": "د.ا",
  "defaultValue": "JOD_د.ا"
}, {
  "key": "KZT",
  "value": "〒",
  "defaultValue": "KZT_〒"
}, {
  "key": "KES",
  "value": "Sh",
  "defaultValue": "KES_Sh"
}, {
  "key": "KWD",
  "value": "د.ك",
  "defaultValue": "KWD_د.ك"
}, {
  "key": "KGS",
  "value": "$",
  "defaultValue": "KGS_$"
}, {
  "key": "LAK",
  "value": "₭",
  "defaultValue": "LAK_₭"
}, {
  "key": "LBP",
  "value": "ل.ل",
  "defaultValue": "LBP_ل.ل"
}, {
  "key": "LSL",
  "value": "L",
  "defaultValue": "LSL_L"
}, {
  "key": "LRD",
  "value": "$",
  "defaultValue": "LRD_$"
}, {
  "key": "LYD",
  "value": "ل.د",
  "defaultValue": "LYD_ل.د"
}, {
  "key": "MKD",
  "value": "ден",
  "defaultValue": "MKD_ден"
}, {
  "key": "MGA",
  "value": "",
  "defaultValue": "MGA_"
}, {
  "key": "MWK",
  "value": "MK",
  "defaultValue": "MWK_MK"
}, {
  "key": "MYR",
  "value": "RM",
  "defaultValue": "MYR_RM"
}, {
  "key": "MVR",
  "value": "ރ.",
  "defaultValue": "MVR_ރ."
}, {
  "key": "MRU",
  "value": "UM",
  "defaultValue": "MRU_UM"
}, {
  "key": "MUR",
  "value": "₨",
  "defaultValue": "MUR_₨"
}, {
  "key": "MXN",
  "value": "$",
  "defaultValue": "MXN_$"
}, {
  "key": "USD",
  "value": "$",
  "defaultValue": "USD_$"
}, {
  "key": "MDL",
  "value": "L",
  "defaultValue": "MDL_L"
}, {
  "key": "MNT",
  "value": "₮",
  "defaultValue": "MNT_₮"
}, {
  "key": "MAD",
  "value": "د.م.",
  "defaultValue": "MAD_د.م."
}, {
  "key": "MZN",
  "value": "MTn",
  "defaultValue": "MZN_MTn"
}, {
  "key": "NAD",
  "value": "$",
  "defaultValue": "NAD_$"
}, {
  "key": "NPR",
  "value": "₨",
  "defaultValue": "NPR_₨"
}, {
  "key": "NZD",
  "value": "$",
  "defaultValue": "NZD_$"
}, {
  "key": "NIO",
  "value": "C$",
  "defaultValue": "NIO_C$"
}, {
  "key": "NGN",
  "value": "₦",
  "defaultValue": "NGN_₦"
}, {
  "key": "KPW",
  "value": "₩",
  "defaultValue": "KPW_₩"
}, {
  "key": "NOK",
  "value": "kr",
  "defaultValue": "NOK_kr"
}, {
  "key": "OMR",
  "value": "ر.ع.",
  "defaultValue": "OMR_ر.ع."
}, {
  "key": "PKR",
  "value": "₨",
  "defaultValue": "PKR_₨"
}, {
  "key": "PAB",
  "value": "B/.",
  "defaultValue": "PAB_B/."
}, {
  "key": "PGK",
  "value": "K",
  "defaultValue": "PGK_K"
}, {
  "key": "PYG",
  "value": "₲",
  "defaultValue": "PYG_₲"
}, {
  "key": "PEN",
  "value": "S/.",
  "defaultValue": "PEN_S/."
}, {
  "key": "PHP",
  "value": "₱",
  "defaultValue": "PHP_₱"
}, {
  "key": "PLN",
  "value": "zł",
  "defaultValue": "PLN_zł"
}, {
  "key": "QAR",
  "value": "ر.ق",
  "defaultValue": "QAR_ر.ق"
}, {
  "key": "RON",
  "value": "L",
  "defaultValue": "RON_L"
}, {
  "key": "RUB",
  "value": "р. ",
  "defaultValue": "RUB_р. "
}, {
  "key": "RWF",
  "value": "₣",
  "defaultValue": "RWF_₣"
}, {
  "key": "WST",
  "value": "T",
  "defaultValue": "WST_T"
}, {
  "key": "STN",
  "value": "Db",
  "defaultValue": "STN_Db"
}, {
  "key": "SAR",
  "value": "ر.س",
  "defaultValue": "SAR_ر.س"
}, {
  "key": "SCR",
  "value": "₨",
  "defaultValue": "SCR_₨"
}, {
  "key": "SLL",
  "value": "Le",
  "defaultValue": "SLL_Le"
}, {
  "key": "SGD",
  "value": "$",
  "defaultValue": "SGD_$"
}, {
  "key": "SBD",
  "value": "$",
  "defaultValue": "SBD_$"
}, {
  "key": "SOS",
  "value": "Sh",
  "defaultValue": "SOS_Sh"
}, {
  "key": "ZAR",
  "value": "R",
  "defaultValue": "ZAR_R"
}, {
  "key": "KRW",
  "value": "₩",
  "defaultValue": "KRW_₩"
}, {
  "key": "LKR",
  "value": "Rs",
  "defaultValue": "LKR_Rs"
}, {
  "key": "SDG",
  "value": "£",
  "defaultValue": "SDG_£"
}, {
  "key": "SRD",
  "value": "$",
  "defaultValue": "SRD_$"
}, {
  "key": "SZL",
  "value": "L",
  "defaultValue": "SZL_L"
}, {
  "key": "SEK",
  "value": "kr",
  "defaultValue": "SEK_kr"
}, {
  "key": "CHF",
  "value": "₣",
  "defaultValue": "CHF_₣"
}, {
  "key": "SYP",
  "value": "ل.س",
  "defaultValue": "SYP_ل.س"
}, {
  "key": "TJS",
  "value": "ЅМ",
  "defaultValue": "TJS_ЅМ"
}, {
  "key": "TZS",
  "value": "Sh",
  "defaultValue": "TZS_Sh"
}, {
  "key": "THB",
  "value": "฿",
  "defaultValue": "THB_฿"
}, {
  "key": "TOP",
  "value": "T$",
  "defaultValue": "TOP_T$"
}, {
  "key": "TTD",
  "value": "$",
  "defaultValue": "TTD_$"
}, {
  "key": "TND",
  "value": "د.ت",
  "defaultValue": "TND_د.ت"
}, {
  "key": "TRY",
  "value": "₤",
  "defaultValue": "TRY_₤"
}, {
  "key": "TMT",
  "value": "m",
  "defaultValue": "TMT_m"
}, {
  "key": "UGX",
  "value": "Sh",
  "defaultValue": "UGX_Sh"
}, {
  "key": "UAH",
  "value": "₴",
  "defaultValue": "UAH_₴"
}, {
  "key": "UYU",
  "value": "$",
  "defaultValue": "UYU_$"
}, {
  "key": "UZS",
  "value": "",
  "defaultValue": "UZS_"
}, {
  "key": "VUV",
  "value": "Vt",
  "defaultValue": "VUV_Vt"
}, {
  "key": "VEF",
  "value": "Bs F",
  "defaultValue": "VEF_Bs F"
}, {
  "key": "VND",
  "value": "₫",
  "defaultValue": "VND_₫"
}, {
  "key": "YER",
  "value": "﷼",
  "defaultValue": "YER_﷼"
}, {
  "key": "ZMW",
  "value": "ZK",
  "defaultValue": "ZMW_ZK"
}, {
  "key": "ZWL",
  "value": "$",
  "defaultValue": "ZWL_$"
}, {
  "key": "DH",
  "value": "د.إ",
  "defaultValue": "DH_د.إ"
}]
}
},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var province = {
  "Vietnam": [{
    "name": "Ho Chi Minh City"
  }, {
    "name": "Hanoi"
  }, {
    "name": "Haiphong"
  }, {
    "name": "Da Nang"
  }, {
    "name": "Can Tho"
  }, {
    "name": "Others"
  }]
};
var _default = province;
exports.default = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ajax;

function ajax(_ref) {
  var data = _ref.data,
      url = _ref.url,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'GET' : _ref$type,
      _success = _ref.success,
      _error = _ref.error,
      headers = _ref.headers,
      xhrFields = _ref.xhrFields;
  var requestData = data;

  if (requestData && type === 'POST') {
    requestData = JSON.stringify(requestData);
  }

  $.ajax({
    data: requestData,
    url: url,
    headers: headers,
    xhrFields: xhrFields,
    type: type,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    success: function success(e) {
      _success && _success(e);
    },
    error: function error(e) {
      _error && _error(e);
    }
  });
}

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLanguage = getLanguage;
exports.setLanguage = setLanguage;
exports.urlFormat = urlFormat;
exports.jumpPage = jumpPage;
exports.isMobileDevice = isMobileDevice;
exports.changeIdSelectorToClassSelector = changeIdSelectorToClassSelector;
exports.parseUrl = parseUrl;
exports.formatDate = formatDate;
exports.formatInterDate = formatInterDate;
exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.deleteCookie = deleteCookie;
exports.checkCookie = checkCookie;
exports.setCookieWithExpiration = setCookieWithExpiration;
exports.debounceWrapper = debounceWrapper;
exports.throttle = throttle;
exports.prefexZone = prefexZone;
exports.showMask = showMask;
exports.hideMask = hideMask;
exports.hidePopOver = hidePopOver;
exports.showPopOver = showPopOver;
exports.handleWinScroll = handleWinScroll;
exports.initFaceBook = initFaceBook;
exports.getPointsSuccessTip = getPointsSuccessTip;
exports.scrollTo = scrollTo;
exports.getSecDomainName = getSecDomainName;
exports.numberFormat = numberFormat;
exports.toogleNavbar = toogleNavbar;
exports.timeFormat = timeFormat;
exports.scrollText = scrollText;
exports.getCountryFile = getCountryFile;
exports.getBuryingPointInfo = getBuryingPointInfo;

var _toastModal = _interopRequireDefault(require("../../components/toastModal"));

var _ajax = _interopRequireDefault(require("./ajax"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollTop; // 监听win top变化

var timer; // 获取语言

function getLanguage() {
  // return $('html')[0].lang ? $('html')[0].lang.toLowerCase() : 'en_us';
  var language = localStorage.getItem('ah-language') || 'en';
  return language;
} //  设置语言


function setLanguage() {
  var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
  localStorage.setItem('ah-language', lang);
} // url格式化


function urlFormat(url) {
  var spaceReg = /\s+/g; // 空格转'-'处理

  var formatReg = /\?+|\/+|#+|%+|\[+|\]+/g; // 特殊字符处理：？、/、#、%

  var repeatSpace = /-+/g; // 多个'-'处理成一个'-'

  return url.replace(spaceReg, '-').replace(formatReg, '').replace(repeatSpace, '-');
} // 跳转页面


function jumpPage(page, openWindow) {
  var href = page;

  if (openWindow) {
    window.open(href);
  } else {
    window.location.href = href;
  }
} // 判断移动or桌面设备


function isMobileDevice() {
  var reg = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;

  if (navigator.userAgent.match(reg)) {
    return true;
  }

  return false;
} // 转换ID选择器为类选择器


function changeIdSelectorToClassSelector(idSelector) {
  return idSelector ? ".".concat(idSelector.substr(1)) : '';
} // 获取url参数


function parseUrl(url) {
  // eslint-disable-next-line
  var pattern = /(\w+)=([\w%\.@-]+)/ig;
  var parames = {}; // eslint-disable-next-line
  // url = decodeURIComponent(url);

  url.replace(pattern, function (a, b, c) {
    parames[b] = c;
  });
  return parames;
}

function formatDate(date) {
  var tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  // 非日期格式，进行字符串处理
  if (Object.prototype.toString.call(date) !== '[object Date]') {
    // eslint-disable-next-line no-param-reassign
    date = date.replace(/-/g, '/');
  }

  var dat = new Date(date);
  var curYear = dat.getFullYear();
  var curMonth = dat.getMonth() + 1 >= 10 ? dat.getMonth() + 1 : "0".concat(dat.getMonth() + 1);
  var curDate = dat.getDate() >= 10 ? dat.getDate() : "0".concat(dat.getDate());
  var curHours = dat.getHours() >= 10 ? dat.getHours() : "0".concat(dat.getHours());
  var curMinute = dat.getMinutes() >= 10 ? dat.getMinutes() : "0".concat(dat.getMinutes());
  var curSecond = dat.getSeconds() >= 10 ? dat.getSeconds() : "0".concat(dat.getSeconds());
  var res = '';

  switch (tag) {
    case 'minute':
      res = "".concat(curYear, "-").concat(curMonth, "-").concat(curDate, " ").concat(curHours, ":").concat(curMinute);
      break;

    case 'second':
      res = "".concat(curYear, "-").concat(curMonth, "-").concat(curDate, " ").concat(curHours, ":").concat(curMinute, ":").concat(curSecond);
      break;

    default:
      res = "".concat(curYear, "-").concat(curMonth, "-").concat(curDate);
  }

  return res;
}
/**
 * 国际日期显示格式
 * @param date 时间字符串
 * @param tag 显示到时分秒还是月
 * @returns {string}
 */


function formatInterDate(date) {
  var tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (Object.prototype.toString.call(date) !== '[object Date]') {
    // eslint-disable-next-line no-param-reassign
    date = date.replace(/-/g, '/');
  }

  var monArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var dat = new Date(date);
  var flag = 'am';
  var curYear = dat.getFullYear();
  var curMonth = monArr[dat.getMonth()];
  var curDate = dat.getDate() >= 10 ? dat.getDate() : "0".concat(dat.getDate());
  var curHours = dat.getHours();

  if (curHours > 12) {
    // eslint-disable-next-line
    curHours = curHours - 12;
    flag = 'pm';
  }

  var curMinute = dat.getMinutes() >= 10 ? dat.getMinutes() : "0".concat(dat.getMinutes());
  var curSecond = dat.getSeconds() >= 10 ? dat.getSeconds() : "0".concat(dat.getSeconds());
  var res = '';

  switch (tag) {
    case 'minute':
      res = "".concat(curMonth, " ").concat(curDate, ", ").concat(curYear, " ").concat(curHours, ":").concat(curMinute, " ").concat(flag);
      break;

    case 'second':
      res = "".concat(curMonth, " ").concat(curDate, ", ").concat(curYear, " ").concat(curHours, ":").concat(curMinute, ":").concat(curSecond, " ").concat(flag);
      break;

    default:
      res = "".concat(curMonth, " ").concat(curDate, ", ").concat(curYear);
  }

  return res;
}
/**
* @method 获取Cookie
* @param  {String} key
* @return {String}
*/


function getCookie(key) {
  var cookies = document.cookie.split(';');
  key = key + '='; //如果刚好key前面一部分是相同的，则可能获取到不是自己当前key的值，所以加上=

  for (var i = 0; i < cookies.length; i += 1) {
    var cookie = cookies[i];

    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }

    if (cookie.indexOf(key) !== -1) {
      return cookie.substring(key.length, cookie.length);
    }
  }

  return '';
}
/**
* @method 设置Cookie
* @param  {String} key
* @return {String}
*/


function setCookie(key, value) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/';
  var cookieDomain = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.aihouse.com';

  if (key && value.toString()) {
    document.cookie = "".concat(key, "=").concat(value, ";path=").concat(path, ";domain=").concat(cookieDomain, ";Max-Age=157680000");
  } else {
    console.error('set cookie need key and value!');
  }
}
/**
* @method 删除Cookie
* @param  {String} key
* @return {String}
*/


function deleteCookie(key) {
  var cookieDomain = '.aihouse.com';

  if (key) {
    var exp = new Date();
    exp.setTime(exp.getTime() + -1 * 24 * 60 * 60 * 1000);
    document.cookie = "".concat(key, "=;path=/;domain=").concat(cookieDomain, ";expires=").concat(exp);
  } else {
    console.error('set cookie need key!');
  }
}
/**
* @method 检查Cookie是否存在
* @param  {String} key
* @return {Boolean}
*/


function checkCookie(key) {
  return !!getCookie(key);
}
/**
* @method 设置cookie,指定过期时间
* @param  {String} key
* @return {Boolean}
*/


function setCookieWithExpiration(key, value, exp) {
  var cookieDomain = '.aihouse.com'; // 创建一个Date对象，表示当前日期和时间  

  var currentDate = new Date(); // 设置时间为当天的23:59:59 UTC时间  

  currentDate.setUTCHours(23, 59, 59, 0); // 将日期对象转换为UTC格式的字符串（以秒为单位）  

  var utcString = currentDate.toUTCString(); // 设置cookie  

  document.cookie = "".concat(key, "=").concat(value, ";path=/;domain=").concat(cookieDomain, ";expires=").concat(exp ? exp : utcString);
}
/**
* @method 函数防抖
* @param  {Function, Number|String}
* @return {Function}
*/


function debounceWrapper(fn) {
  var debounceTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  // eslint-disable-next-line
  var timer;
  return function () {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(function () {
      fn();
      timer = null;
    }, debounceTime);
  };
}
/**
 * @method 函数节流
 * @param {Function, Number|String}
 * @return {Function}
*/
// 简单的节流函数


function throttle(func, wait, mustRun) {
  var timeout;
  var startTime = new Date();
  return function () {
    var context = this; // eslint-disable-next-line prefer-rest-params

    var args = arguments;
    var curTime = new Date();
    clearTimeout(timeout); // 如果达到了规定的触发时间间隔，触发 handler

    if (curTime - startTime >= mustRun) {
      func.apply(context, args);
      startTime = curTime; // 没达到触发间隔，重新设定定时器
    } else {
      timeout = setTimeout(func, wait);
    }
  };
}
/**
* @method 位数补0
* @param  {Number, Number}
* @return {Number}
*/


function prefexZone(num, n) {
  return (Array(n).join(0) + num).slice(-n);
}
/**
* @method 生成模态框
* @param  {String, Bollean, Function}
*/


function showMask(option, callback) {
  var _option$color = option.color,
      color = _option$color === void 0 ? 'transparent' : _option$color,
      _option$zIndex = option.zIndex,
      zIndex = _option$zIndex === void 0 ? 1031 : _option$zIndex,
      _option$maskClick = option.maskClick,
      maskClick = _option$maskClick === void 0 ? true : _option$maskClick,
      _option$el = option.el,
      el = _option$el === void 0 ? '.base-layout' : _option$el,
      _option$fixed = option.fixed,
      fixed = _option$fixed === void 0 ? false : _option$fixed;
  scrollTop = $('html').scrollTop();
  $(el).prepend("<div class=\"ahm-modal-mask\" style=\"background-color: ".concat(color, "; z-index: ").concat(zIndex, "\"></div>"));

  if (fixed) {
    $('body').css({
      overflow: 'hidden',
      position: 'fixed',
      top: $('html').scrollTop() * -1
    });
  }

  if (maskClick) {
    $(el).on('click', '.ahm-modal-mask', function () {
      $(this).remove();

      if (fixed) {
        $('body').css({
          overflow: 'auto',
          position: 'static',
          top: 'auto'
        });
        $('html').scrollTop(scrollTop);
      } // eslint-disable-next-line no-unused-expressions


      callback && callback();
    });
  }
}
/**
* @method 取消模态框
* @param  {Boolean}
*/


function hideMask() {
  var isFixed = $('.base-layout').css('position');

  if (isFixed === 'fixed') {
    $('body').css({
      overflow: 'auto',
      position: 'static',
      top: 'auto'
    });
    $('html').scrollTop(scrollTop);
  }

  $('.ahm-modal-mask').remove();
}
/**
 * @method 取消气泡框
 * @param {el, Height}
 */


function hidePopOver(el) {
  $(el).find('.ahm-popOver__content').css({
    height: 0
  });
  setTimeout(function () {
    $(el).find('.ahm-popOver').removeClass('show');
  }, 240);
}
/**
 * @method 生成气泡框
 * @param {el, Height}
 */


function showPopOver(el, height) {
  $(el).find('.ahm-popOver').addClass('show');
  $(el).find('.ahm-popOver__content').css({
    height: height
  });
  showMask({
    el: el
  }, function () {
    hidePopOver(el);
  });
}
/**
 * @method 监听window滚动
 * @param {el, callback}
 */


function handleWinScroll(el, callback) {
  $(window).scroll(function () {
    var screenHeight = $(window).height();
    var winScrollTop = $(document).scrollTop();

    if ($(el).length > 0) {
      var offsetTop = $(el).offset().top;

      if (winScrollTop + screenHeight > offsetTop) {
        // eslint-disable-next-line no-unused-expressions
        callback && callback();
      }
    }
  });
}
/**
 * @method 初始化facebook
 * @param {el, callback}
 */


function initFaceBook() {
  console.log('initFacebook'); // facebook登录初始化

  window.fbAsyncInit = function () {
    var facebookClientId = $('#facebookClientId').val();
    FB.init({
      appId: facebookClientId,
      cookie: true,
      // enable cookies to allow the server to access
      xfbml: true,
      // parse social plugins on this page
      version: 'v3.2'
    });
  };

  (function (d, s, id) {
    var js;
    var fjs = d.getElementsByTagName(s)[0];

    if (d.getElementById(id)) {
      return;
    } // eslint-disable-next-line prefer-const


    js = d.createElement(s);
    js.id = id;
    js.src = '//connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk');
}
/**
 * 获取积分成功提示
 * @param num task 任务名称
 */


function getPointsSuccessTip(num, task) {
  (0, _toastModal.default)({
    iconClass: 'icon-chenggong',
    content: "".concat($.i18n.prop('integral.success.tip1'), " ").concat(num, " ").concat($.i18n.prop('integral.success.tip2'), " ").concat(task, "!")
  });
}
/**
 * @method 页面滚动到指定元素
 * @param {el, callback}
 */


function scrollTo(dom) {
  var topHeight = $('.base-header__country').height() + $('.base-header__nav').height();
  var scrollTops = $(dom).offset().top - topHeight;
  $('html,body').animate({
    scrollTop: scrollTops
  }, 1000);
}
/**
 * @method 获取二级域名
 * @param {url: String}
 */


function getSecDomainName(url) {
  return url.split('.')[0].split('//')[1];
}
/**
 * 整数逢三断一
 * @param value
 */


function numberFormat(value) {
  if (!value) {
    return '0';
  }

  var result = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); // 将整数部分逢三一断

  return result;
}
/**
 * @method 导航栏切换（品牌馆）
 * @param {el}
* */


function toogleNavbar() {
  $(window).scroll(function () {
    clearTimeout(timer);

    if ($(document).scrollTop() > 100) {
      $('#navbarContent').addClass('rollUp');
      $('#navbarBrand').removeClass('rollUp');
      timer = setTimeout(function () {
        $('.navbarBrand-wpt').addClass('visible');
      }, 200);
    } else {
      $('#navbarContent').removeClass('rollUp');
      $('#navbarBrand').addClass('rollUp');
      $('.navbarBrand-wpt').removeClass('visible');
    }
  });
}
/**
 * 时间展示（00''00'）
 * @param value
 */


function timeFormat(value) {
  var val = Number(value);
  var hourText = '';

  if (val > 60) {
    var min = parseInt(val / 60, 0);
    var minutes = prefexZone(min, min.length);
    var seconds = prefexZone(val % 60, 2);
    hourText = "".concat(minutes, ":").concat(seconds);
  } else {
    hourText = "00:".concat(val);
  }

  return hourText;
}
/**
 * marquee效果
 * @return void
 */


function scrollText(ID) {
  var scrollingDiv = document.getElementById(ID);
  scrollingDiv.innerHTML += scrollingDiv.innerHTML; // 函数实现无缝滚动效果

  function startScroll() {
    scrollingDiv.style.transform = "translateX(0)";
    scrollingDiv.style.animationPlayState = "running";
  }

  function stopScroll() {
    scrollingDiv.style.animationPlayState = "paused";
  }

  scrollingDiv.addEventListener("mouseenter", stopScroll);
  scrollingDiv.addEventListener("mouseleave", startScroll);
  startScroll();
}
/**
 * 请求国家文件
 * @return void
 */


function getCountryFile(cb) {
  (0, _ajax.default)({
    url: 'https://ai-study1.oss-cn-shenzhen.aliyuncs.com/prod/static/common/country.json',
    type: 'GET',
    success: function success(res) {
      cb && cb(res);
    }
  });
} //获取埋点相关基础数据


function getBuryingPointInfo() {
  var userInfo = {};
  var emailObj = $("#userInfo_email");

  if (emailObj != null && emailObj.val() !== undefined && emailObj.val() !== '') {
    userInfo.account = emailObj.val();
  } else {
    userInfo.account = "";
  }

  var userIdObj = $("#userInfo_userId");

  if (userIdObj != null && userIdObj.val() !== undefined && userIdObj.val() !== '') {
    userInfo.userId = userIdObj.val();
    userInfo.isLogin = 1;
  } else {
    userInfo.userId = "";
    userInfo.isLogin = 0;
  }

  userInfo.ip = $("#userip").val();
  var countryObj = $("#userInfo_country");

  if (countryObj != null && countryObj.val() !== undefined && countryObj.val() !== '') {
    userInfo.country = countryObj.val();
  } else {
    userInfo.country = "";
  }

  var organTypeObj = $("#userInfo_isFactory");

  if (organTypeObj != null && organTypeObj.val() !== undefined && organTypeObj.val() !== '') {
    userInfo.organType = organTypeObj.val() === "1" ? "企业" : "零售";
  } else {
    userInfo.organType = "";
  }

  var organIdObj = $("#userInfo_organId");

  if (organIdObj != null && organIdObj.val() !== undefined && organIdObj.val() !== '') {
    userInfo.organId = organIdObj.val();
  } else {
    userInfo.organId = "";
  }

  userInfo.pageUrl = window.location.href;
  userInfo.referrerUrl = document.referrer;
  userInfo.channelCode = getCookie("aihouse_channel_code");
  userInfo.hw_device = isMobileDevice() ? "mobile" : "PC";
  return userInfo;
}

},{"../../components/toastModal":12,"./ajax":3}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleDesignerLink = handleDesignerLink;
exports.initMDesignSwiper = initMDesignSwiper;

var _common = require("../../common/js/common");

// eslint-disable-next-line import/prefer-default-export
function handleDesignerLink() {
  $('.js-designer-item').click(function () {
    var userId = $(this).attr('data-userId');
    var name = $(this).attr('data-name');
    var url = "/designGallery/mainPage/".concat((0, _common.urlFormat)(name), "-").concat(userId);

    if ((0, _common.isMobileDevice)()) {
      (0, _common.jumpPage)(url, false);
    } else {
      (0, _common.jumpPage)(url, true);
    }
  });
} // 初始化移动端-设计师swiper


function initMDesignSwiper() {
  if ((0, _common.isMobileDevice)()) {
    // eslint-disable-next-line no-unused-vars
    var swiper = new Swiper('#m_designerSwiper', {
      watchOverflow: true,
      spaceBetween: 16,
      lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: true
      },
      centeredSlides: true,
      slidesPerView: 'auto'
    });
  }
}

},{"../../common/js/common":4}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleSchemeLink = handleSchemeLink;

var _common = require("../../common/js/common");

// eslint-disable-next-line import/prefer-default-export
function handleSchemeLink() {
  $('.base-layout').on('click', '.js-scheme-item', function () {
    var parentDom = $(this).parents('.scheme-item');
    var name = parentDom.attr('data-schemeName');
    var schemeId = parentDom.attr('data-schemeId');
    var userId = parentDom.attr('data-userId');
    var url = "/scheme/".concat((0, _common.urlFormat)(name), "-").concat(schemeId, ".").concat(userId);

    if ((0, _common.isMobileDevice)()) {
      (0, _common.jumpPage)(url, false);
    } else {
      (0, _common.jumpPage)(url, true);
    }
  });
  $('.base-layout').on('click', '.js-homePage', function (e) {
    e.stopPropagation();
    var parentDom = $(this).parents('.scheme-item');
    var author = parentDom.attr('data-author');
    var userId = parentDom.attr('data-userId');
    var url = "/designGallery/mainPage/".concat((0, _common.urlFormat)(author), "-").concat(userId);

    if ((0, _common.isMobileDevice)()) {
      (0, _common.jumpPage)(url, false);
    } else {
      (0, _common.jumpPage)(url, true);
    }
  });
}

},{"../../common/js/common":4}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initHomeSwiper = initHomeSwiper;

var _common = require("../common/js/common");

var _loginRegisterModal = require("./loginRegisterModal");

var _graphModal = require("./models/graphModal");

// import showContactModal from './contactUsModal';
var isMobile = (0, _common.isMobileDevice)(); // 初始化方案轮播图
// eslint-disable-next-line import/prefer-default-export

function initHomeSwiper() {
  if ((0, _common.isMobileDevice)()) {
    initMSwiper();
  } else {
    initSwiper();
  }

  function initSwiper() {
    var domLenth = $('#homeSwiper .swiper-wrapper li').length; // eslint-disable-next-line no-unused-vars

    var homeSwiper; // eslint-disable-next-line

    if (domLenth > 1) {
      $('.home-swiper__navigation').show();
      homeSwiper = new Swiper('#homeSwiper', {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        loop: false,
        watchOverflow: true,
        lazy: {
          loadPrevNext: true,
          loadOnTransitionStart: true
        },
        navigation: {
          nextEl: '#homeSwiper .swiper-button-next',
          prevEl: '#homeSwiper .swiper-button-prev'
        }
      });
    } else {
      homeSwiper = new Swiper('#homeSwiper', {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        loop: false,
        watchOverflow: true,
        noSwiping: true,
        lazy: {
          loadPrevNext: true,
          loadOnTransitionStart: true
        }
      });
      $('#homeSwiper .home-swiper__navigation-wrapper').css('display', 'none');
    }
  }

  function initMSwiper() {
    var domLenth = $('#m-homeSwiper .swiper-wrapper li').length; // eslint-disable-next-line no-unused-vars

    var homeSwiper; // eslint-disable-next-line

    if (domLenth > 1) {
      $('.home-swiper__navigation').show();
      homeSwiper = new Swiper('#m-homeSwiper', {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        loop: false,
        watchOverflow: true,
        lazy: {
          loadPrevNext: true,
          loadOnTransitionStart: true
        },
        navigation: {
          nextEl: '#m-homeSwiper .swiper-button-next',
          prevEl: '#m-homeSwiper .swiper-button-prev'
        }
      });
    } else {
      homeSwiper = new Swiper('#m-homeSwiper', {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        loop: false,
        watchOverflow: true,
        noSwiping: true,
        lazy: {
          loadPrevNext: true,
          loadOnTransitionStart: true
        }
      });
      $('#m-homeSwiper .home-swiper__navigation-wrapper').css('display', 'none');
    }
  }

  $('.js-homeSwiper__toRegister').click(function () {
    var url = $(this).attr('data-url');

    if (isMobile) {
      (0, _common.jumpPage)(url, false);
    } else {
      (0, _loginRegisterModal.showRegisterModal)('resetForm');
    }
  });
  $('.js-homeSwiper__toDesignGallery').click(function () {
    (0, _common.jumpPage)('/download');
    /*const url = $(this).attr('data-url');
    if (url) {
      jumpPage(url || '/designGallery');
    } else {
      showLoginModal('resetForm');
    }*/
  });
  $('.js-homeSwiper__toDesign').click(function () {
    var url = $(this).attr('data-url');

    if (url) {
      (0, _common.jumpPage)(url, true);
    } else {
      // showRegisterModal('resetForm');
      (0, _graphModal.graphModalOnlyUrl)('/graph/reg');
    }
  });
  $('.js-homeSwiper__toContact').click(function () {
    // if (isMobile) {
    (0, _common.jumpPage)('/contact?type=partner', false); // } else {
    //   showContactModal('partner');
    // }
  });
  $('.js-homeSwiper__toContactUs').click(function () {
    // if (isMobile) {
    (0, _common.jumpPage)('/contact', false); // } else {
    //   showContactModal('', {
    //     insterest: $(this).attr('data-insterest') || '',
    //   });
    // }
  }); // 含有attachUrl就跳转

  $('.js-swiper-slide').not('.swiper-notjump').click(function () {
    var url = $(this).attr('data-attachUrl');
    (0, _common.jumpPage)(url, !isMobile);
  });
}

},{"../common/js/common":4,"./loginRegisterModal":8,"./models/graphModal":10}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showLoginModal = showLoginModal;
exports.showRegisterModal = showRegisterModal;
exports.showRegisterNextModal = showRegisterNextModal;
exports.showSetEmailModal = showSetEmailModal;
exports.showVerifyModal = showVerifyModal;
exports.handleInvitedRegister = handleInvitedRegister;
exports.initLoginRegister = initLoginRegister;

var _ajax = _interopRequireDefault(require("../common/js/ajax"));

var _common = require("../common/js/common");

var _loginTipsModal = require("./loginTipsModal");

var _country = _interopRequireDefault(require("../assert/country/country.json"));

var _province = _interopRequireDefault(require("../assert/country/province"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 变量
var hasValid = false;
var roleValue = '';
var countryValue = '';
var provinceValue = '';
var loginFormValidate;
var registerFormValidate;
var modifyPassFormValidate;
var retrieveFormValidate;
var fullCountryListHTML = '';
var tempStr; // 邀请码相关字段

var chooseRole; // 注册-选择的角色， true：专业；  false：非专业

var ssoUrl = $('#sso').val(); //let ssoLoginUrl = ssoUrl.replace("graph-new","graph");

var ssoLoginUrl = ssoUrl;
var urlMatch = window.location.href.match(/\/\/(.*)\.aihouse/); // 设置倒计时

var count = 60;
var timer;
var provinceArr = []; // 初始化登录内容/字段展示

function initLoginContentShow() {
  if ((0, _common.getCookie)('OPEN_ID')) {
    $('#accountLogin').text($.i18n.prop('component.loginRegister.signInAndBind'));
    $('.loginRegister-modal .login .page__tips, .page__third').hide();
    $('.loginRegister-modal .login .page__link').show();
  } else {
    $('#accountLogin').text($.i18n.prop('component.loginRegister.signIn'));
    $('.loginRegister-modal .login .page__tips, .page__third').show();
    $('.loginRegister-modal .login .page__link').hide();
  }

  if (urlMatch[1] === 'my') {
    $('.loginRegister-modal .login .page__third').hide();
  }
} // 初始化注册内容/字段展示


function initRegisterContentShow() {
  if ((0, _common.getCookie)('OPEN_ID')) {
    $('.loginRegister-modal .register .page__title').text($.i18n.prop('component.loginRegister.associated_account'));
    $('.loginRegister-modal .register .page__desc').hide();
    $('.loginRegister-modal .register .page__button').text($.i18n.prop('component.loginRegister.next'));
    $('.loginRegister-modal .register .page__tips').hide();
    $('.loginRegister-modal .register .page__link').show();
  } else {
    $('.loginRegister-modal .register .page__title').text($.i18n.prop('component.loginRegister.signUp'));
    $('.loginRegister-modal .register .page__desc').show();
    $('.loginRegister-modal .register .page__button').text($.i18n.prop('component.loginRegister.signUp'));
    $('.loginRegister-modal .register .page__tips').show();
    $('.loginRegister-modal .register .page__link').hide();
  }
}
/*
 * 显示/隐藏省份下拉框
 */


function toggleProvince(type) {
  if (type) {
    $('.reg__province').css({
      width: '49%'
    }).addClass('active');
    $('.reg__province .form-select').css({
      overflow: 'visible'
    });
    $('.reg__state').css({
      width: '49%'
    });
  } else {
    $('.reg__province').css({
      width: 0
    }).removeClass('active');
    $('.reg__province .form-select').css({
      overflow: 'hidden'
    });
    $('.reg__state').css({
      width: '100%'
    });
  }
}
/**
 * 设置省份下拉框
 */


function setProvinceDropdown() {
  var $province = $('#regForm #province');
  $province.val('');

  if (!provinceArr || provinceArr.length === 0) {
    toggleProvince(false);
    $province.rules().required && $province.rules('remove', 'required');
    return;
  }

  toggleProvince(true);
  $province.rules('add', {
    required: true,
    messages: {
      required: $.i18n.prop('component.loginRegister.province_required')
    }
  });
  var provinceHtml = '';
  provinceArr.forEach(function (item) {
    provinceHtml += "<li class=\"dropdown-item\" data-value=\"".concat(item.name, "\">").concat(item.name, "</li>");
  });
  $('.reg__province .dropdown-menu .mCSB_container').html(provinceHtml);
} // 初始化省份


function initProvinceDropdown() {
  provinceArr = [];
  provinceValue = '';
  $('#province').val('');
  setProvinceDropdown();
} // 注册弹窗-监听省份选中


function onProvinceDropdownItemClick() {
  $('body').on('click', '.loginRegister-modal .reg__province .dropdown-item', function () {
    $('#province').val($(this).text()); // $('#province').val($(e.target).text());
    // 使用this解决翻译新增font元素问题，点击font元素e.target为font元素

    provinceValue = $(this).data('value');
    $(this).addClass('active').siblings('.active').removeClass('active');

    if (hasValid) {
      $('#regForm').valid();
    }
  });
} // 注册弹窗-监听职业领域选中


function onRoleDropdownItemClick() {
  $('body').on('click', '.loginRegister-modal .reg__role .dropdown-item', function () {
    gtag('event', 'select', {
      event_category: '页面-注册',
      event_label: '职业领域'
    });
    $('#role').val($(this).text());
    roleValue = $(this).data('value');

    if (hasValid) {
      $('#regForm').valid();
    }
  });
} // 注册弹窗-监听国家选中


function onCountryDropdownItemClick() {
  $('body').on('click', '.loginRegister-modal .reg__state .dropdown-item', function (e) {
    e.stopImmediatePropagation();
    $(this).addClass('active');
    $(this).siblings('.active').removeClass('active');
    $('#state').val($(this).text());
    countryValue = $(this).data('value'); // 国家选择是马来就添加单独的电话号码校验

    var dom = $('#regForm #mobile');
    var value = $(this).data('value');
    /* eslint-disable */

    if (value === 'Malaysia' || value === 'Singapore') {
      $('#mobile-error').remove();

      if (value === 'Malaysia') {
        $(dom).rules().singaporeMobile && $(dom).rules('remove', 'singaporeMobile');
        $(dom).rules().myMobile || $(dom).rules('add', {
          myMobile: true
        });
      } else if (value === 'Singapore') {
        $(dom).rules().myMobile && $(dom).rules('remove', 'myMobile');
        $(dom).rules().singaporeMobile || $(dom).rules('add', {
          singaporeMobile: true
        });
      }

      $(dom).rules().rangelength && $(dom).rules('remove', 'rangelength'); // 更改required校验的文案并进行校验

      $('#mobile').prop('placeholder', $.i18n.prop('component.loginRegister.mobile_tip'));
      $('#regForm').validate().settings.messages.mobile.required = $.i18n.prop('component.loginRegister.mobile_tip');
      $('#regForm').validate().element($('#mobile'));
    } else {
      $('#mobile').prop('placeholder', $.i18n.prop('component.loginRegister.mobile_placeholder'));
      $(dom).rules().myMobile && $(dom).rules('remove', 'myMobile');
      $(dom).rules().singaporeMobile && $(dom).rules('remove', 'singaporeMobile');
      $(dom).rules().rangelength || $(dom).rules('add', {
        rangelength: [7, 15]
      }); // 还原required校验的文案并消除一开始显示

      $('#mobile-error').remove();
      $('#regForm').validate().settings.messages.mobile.required = $.i18n.prop('component.loginRegister.mobile_tip1');
    }

    if (hasValid) {
      $('#regForm').valid();
    } // 设置关联省份下拉框


    provinceArr = _province.default[$(this).data('value')];
    setProvinceDropdown();
    $('#countryDropdown').dropdown('toggle'); // 手动调用国家下拉框收起
  });
}
/**
 * 注册弹窗-国家输入搜索
 * @return void
 * */


function handleCountrySearch() {
  $('#state').on('input propertychange', function (e) {
    var THIS = this;
    (0, _common.debounceWrapper)(function () {
      var countryListHTML = '';
      var value = $(THIS).val().trim().toLowerCase();
      countryValue = ''; // 清空

      _country.default.country.forEach(function (item) {
        var className = "bg-".concat(item.image.split('.')[0]); // 搜索符合内容的国家信息

        var itemName = $.i18n.prop('properties.' + item.id);

        if (itemName.toLowerCase().includes(value)) {
          // 输入的内容匹配
          if (itemName.toLowerCase() === value) {
            countryValue = item.name;
          }

          if (urlMatch && urlMatch[1] === item.id.toLowerCase()) {
            $('#state').val(itemName);
            countryListHTML += "<li class=\"dropdown-item active\" data-value=\"".concat(item.name, "\" data-site=\"").concat(item.id.toLowerCase(), "\"><div style=\"display: inline-block\" class=\"").concat(className, "\"></div> ").concat(itemName, " </li>");
          } else {
            countryListHTML += "<li class=\"dropdown-item\" data-value=\"".concat(item.name, "\" data-site=\"").concat(item.id.toLowerCase(), "\"><div style=\"display: inline-block\" class=\"").concat(className, "\"></div> ").concat(itemName, " </li>");
          }
        }
      });

      $('.loginRegister-modal .reg__state .dropdown-menu .mCSB_container').html(countryListHTML);
      var countryWptShow = $('.loginRegister-modal .reg__state').hasClass('show');

      if (!countryWptShow) {
        $('#state').click(); // 弹出国家列表
      }
    })();
  });
} // 设置职业领域下拉列表


function setRoleDropdownList() {
  var roleLength = 9;
  var ROLE = [$.i18n.prop('component.loginRegister.role1'), $.i18n.prop('component.loginRegister.role2'), $.i18n.prop('component.loginRegister.role3'), $.i18n.prop('component.loginRegister.role4'), $.i18n.prop('component.loginRegister.role5'), $.i18n.prop('component.loginRegister.role6'), $.i18n.prop('component.loginRegister.role7'), $.i18n.prop('component.loginRegister.role8'), $.i18n.prop('component.loginRegister.role9')];
  var roleListHtml = '';

  for (var i = 0; i < roleLength; i += 1) {
    if (i != 4 && i != 5) {
      roleListHtml += "<li class=\"dropdown-item\" data-value=\"".concat(i + 1, "\">").concat(ROLE[i], "</li>");
    }
  }

  $('.loginRegister-modal .reg__role .dropdown-menu').html(roleListHtml);
  onRoleDropdownItemClick();
} // 设置国家下拉列表


function setCountryDropdownList() {
  var countryListHTML = '';
  var countries = [];

  _country.default.country.forEach(function (item) {
    item.i18nName = $.i18n.prop('properties.' + item.id);
    countries.push(item);
  });

  countries.sort(function (prop) {
    return function (a, b) {
      return a[prop].localeCompare(b[prop]);
    };
  }('i18nName'));
  countries.forEach(function (item) {
    var className = "bg-".concat(item.image.split('.')[0]);

    if (urlMatch && urlMatch[1] === item.id.toLowerCase()) {
      $('#state').val(item.i18nName);
      countryValue = item.name;
      countryListHTML += "<li class=\"dropdown-item active\" data-value=\"".concat(item.name, "\" data-site=\"").concat(item.id.toLowerCase(), "\"><div style=\"display: inline-block\" class=\"").concat(className, "\"></div> ").concat(item.i18nName, " </li>");
    } else {
      countryListHTML += "<li class=\"dropdown-item\" data-value=\"".concat(item.name, "\" data-site=\"").concat(item.id.toLowerCase(), "\"><div style=\"display: inline-block\" class=\"").concat(className, "\"></div> ").concat(item.i18nName, " </li>");
    }
  });
  fullCountryListHTML = countryListHTML;
  $('.loginRegister-modal .reg__state .dropdown-menu').html(countryListHTML);
  onCountryDropdownItemClick();
  handleCountrySearch();
} // 表单验证


function loginFormValid() {
  loginFormValidate = $('#loginForm').validate({
    rules: {
      account: {
        required: true
      },
      password: {
        required: true
      }
    },
    messages: {
      account: {
        required: $.i18n.prop('component.loginRegister.account_required')
      },
      password: {
        required: $.i18n.prop('component.loginRegister.password_required')
      }
    }
  });
} // 表单验证


function registerFormValid() {
  registerFormValidate = $('#regForm').validate({
    rules: {
      email: {
        required: true,
        email: true
      },
      password: {
        required: true,
        slphicCombinate: true
      },
      username: {
        required: false
      },
      mobile: {
        required: false,
        rangelength: [7, 15]
      },
      role: {
        required: false
      },
      country: {
        required: true
      },
      ivtCode: {// rangelength: [8, 8],
      }
    },
    messages: {
      email: {
        required: $.i18n.prop('component.loginRegister.email_equire'),
        email: $.i18n.prop('component.loginRegister.email_invalid')
      },
      password: {
        required: $.i18n.prop('component.loginRegister.password_tip'),
        slphicCombinate: $.i18n.prop('component.loginRegister.password_tip')
      },
      // username: {
      //     required: $.i18n.prop('component.loginRegister.name_required'),
      // },
      mobile: {
        // required: $.i18n.prop('component.loginRegister.mobile_required'),
        rangelength: $.i18n.prop('component.loginRegister.mobile_rangth')
      },
      // role: {
      //     required: $.i18n.prop('component.loginRegister.occupation_required'),
      // },
      country: {
        required: $.i18n.prop('component.loginRegister.country_required')
      },
      ivtCode: {// rangelength: $.i18n.prop('component.loginRegister.ivtCode'),
      }
    }
  });
} // 输入验证码表单验证


function verifyFormValid() {
  $('#verForm').validate({
    rules: {
      code: {
        required: true,
        digits: true,
        rangelength: [6, 6]
      }
    },
    messages: {
      code: {
        required: $.i18n.prop('component.loginRegister.code_required'),
        digits: $.i18n.prop('component.loginRegister.code_invalid'),
        rangelength: $.i18n.prop('component.loginRegister.code_invalid')
      }
    }
  });
} // email登录


function accountLogin() {
  if ($('#loginForm').valid()) {
    (0, _ajax.default)({
      data: {
        account: $('#account').val(),
        password: $('#password').val()
      },
      url: "".concat(ssoLoginUrl, "/validate"),
      xhrFields: {
        withCredentials: true
      },
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      type: 'POST',
      success: function success(res) {
        var isLogin = res && res.success;
        var organId = "";
        var userId = "";
        var country = "";

        if (isLogin && res.exResult1) {
          var userResult = res.exResult1;
          organId = userResult.organId;
          userId = userResult.userId;

          if (userResult.country != null) {
            country = userResult.country;
          }
        }

        var userInfo = (0, _common.getBuryingPointInfo)(); //神策埋点

        if (window && window.VSensors) {
          var data = {
            organ_type: "零售",
            account: $('#account').val(),
            hw_user_id: userId,
            ip: userInfo.ip,
            country: country,
            organ_id: organId,
            page_url: window.location.href,
            referrer: document.referrer,
            is_success: isLogin,
            channel_code: (0, _common.getCookie)("aihouse_channel_code"),
            hw_login_method: $('#account').val().indexOf("@") > 0 ? "email" : "account",
            button: "final log in",
            hw_device: userInfo.hw_device
          };
          console.log("开始记录日志,数据为:" + JSON.stringify(data));
          window.vSensors.track('AIHOUSE_LOGIN', data);
        }

        if (res && res.success) {
          (0, _common.setCookie)('exResult', res.exResult);
          (0, _common.setCookie)('exResultFlag', res.exResultFlag);
          var viewModel = Number((0, _common.getCookie)('web_view_mode'));

          if (!viewModel || viewModel === 0) {
            (0, _common.setCookie)('web_view_mode', res.errorCode);
          } //var domain = location.protocol + "//" + location.host;


          var domain = document.location.href;
          var newUrl = changeUrlArg(res.result, "callbackurl", domain);
          window.location.href = newUrl;
        } else {
          (0, _loginTipsModal.loginTipsModal)({
            title: $.i18n.prop('component.loginRegister.tips'),
            content: res.errorMessage,
            button: $.i18n.prop('component.loginRegister.ok')
          });
        }
      }
    });
  }
}

function changeUrlArg(url, arg, val) {
  var pattern = arg + '=([^&]*)';
  var replaceText = arg + '=' + val;
  return url.match(pattern) ? url.replace(eval('/(' + arg + '=)([^&]*)/gi'), replaceText) : url.match('[\?]') ? url + '&' + replaceText : url + '?' + replaceText;
} // 监听email登录按钮点击


function onAccountLoginClick() {
  $('body').on('click', '#accountLogin', function () {
    gtag('event', 'click', {
      event_category: '页面-登录',
      event_label: '邮箱登录按钮'
    });
    accountLogin();
  });
} // 电话输入限制


function handleMobileIpt() {
  $('#mobile, #retrieve_mobile, #activateMobile').bind('input onpropertychange', function func() {
    var obj = this;
    var max = $(obj).attr('data-max');

    if (obj.value.length > max) {
      obj.value = obj.value.slice(0, max);
    }
  });
  $('#mobile, #retrieve_mobile, #activateMobile').keypress(function (e) {
    var key = e.keyCode || e.which;
    key = String.fromCharCode(key);
    var regex = /[0-9]|\./;

    if (!regex.test(key)) {
      e.returnValue = false;

      if (e.preventDefault) {
        e.preventDefault();
      }
    }
  });
  $('#mobile, #retrieve_mobile, #activateMobile').on('mousewheel DOMMouseScroll', function (evt) {
    var e = evt || window.event;

    if (e.preventDefault) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      e.cancelBubble = true;
      e.returnValue = false;
    }

    return false;
  });
  /* eslint-disable */

  $('#mobile, #retrieve_mobile, #activateMobile').keydown(function func(e) {
    var target = e.target;
    var max = $(this).attr('data-max');
    var keyId = e.keyCode;
    var isDelete = false;

    switch (keyId) {
      case 8:
        isDelete = true;
        break;

      case 46:
        isDelete = true;
        break;

      default:
        break;
    }

    if (!isDelete && target.value.length === max) {
      return false;
    }
  });
  /* eslint-disable */
} // 密码格式校验


function validPassword() {
  $.validator.addMethod('slphicCombinate', function valid(value, element) {
    var rangeLength = false;
    var len = value.length;

    if (len > 0) {
      $('.reg-password__previous').hide();
    }

    if (6 <= len && len <= 20) {
      rangeLength = true;
    }

    var pattern = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]*$/;
    return this.optional(element) || pattern.test(value) && rangeLength;
  }, $.i18n.prop('component.loginRegister.password_tip'));
} // 马来和新加坡两种手机号码格式校验


function validMyAndSingaporeMobile() {
  $.validator.addMethod('myAndSingaporeMobile', function valid(value, element) {
    var pattern = /^(011[0-9]{8})|(01[0|2|3|4|5|6|7|8|9][0-9]{7})|((8|9)\d{7})$/;
    return this.optional(element) || pattern.test(value);
  }, $.i18n.prop('component.loginRegister.mobile_myandsingapore'));
} // 马来手机号码格式校验


function validMyMobile() {
  $.validator.addMethod('myMobile', function valid(value, element) {
    var pattern = /^(011[0-9]{8})|(01[0|2|3|4|5|6|7|8|9][0-9]{7})$/;
    return this.optional(element) || pattern.test(value);
  }, $.i18n.prop('component.loginRegister.mobile_my'));
}
/**
 * 新加坡手机号码格式校验
 * */


function validSingapore() {
  $.validator.addMethod('singaporeMobile', function valid(value, element) {
    var pattern = /(8|9)\d{7}$/;
    return this.optional(element) || pattern.test(value);
  }, $.i18n.prop('component.loginRegister.mobile_singapore'));
} // 验证码格式校验，只能输入数字、字母


function validCode() {
  $.validator.addMethod('codeSlphicCombinate', function valid(value, element) {
    var pattern = /^[0-9A-Za-z]*$/;
    return this.optional(element) || pattern.test(value);
  }, $.i18n.prop('component.loginRegister.mobile_code'));
} // 注册-检查协议是否勾选


function checkProtocolChecked() {
  if ($('#protocol').is(':checked')) {
    $('.reg__protocol').removeClass('invalid');
    return true;
  }

  if (hasValid) {
    $('.reg__protocol').addClass('invalid');
  }

  return false;
} // 注册-协议点击


function onProtocolCheckboxClick() {
  $('#protocolCheckbox').click(function () {
    checkProtocolChecked();
  });
} // 查看协议阻止冒泡


function onProtocolLinkClick() {
  $('.reg__protocol-link').click(function func(e) {
    e.stopPropagation();
    gtag('event', 'click', {
      event_category: '页面-注册',
      event_label: '用户协议按钮'
    });
  });
} // 回车登录


function enterLogin() {
  $('body').on('keydown', '.loginRegister-modal .form-login', function (e) {
    if (e.keyCode === 13) {
      $('#accountLogin').click();
    }
  });
} // 注册-提交表单


function register() {
  $('.reg-password__previous').hide();
  hasValid = true;
  var isProtocolChecked = checkProtocolChecked();

  if ($('#regForm').valid() && isProtocolChecked) {
    var params = {
      email: $('#email').val(),
      password: $('#regPassword').val(),
      nickName: $('#username').val(),
      mobile: $('#mobile').val(),
      industry: chooseRole ? roleValue : '',
      country: countryValue,
      profession: true,
      ivtCode: $('#ivtCode').val()
    };

    if ($('.reg__province').hasClass('active')) {
      params.province = provinceValue;
    } // 校验输入的国家信息是否存在于国家列表的数据


    if (!countryValue) {
      (0, _loginTipsModal.loginTipsModal)({
        title: $.i18n.prop('component.loginRegister.tips'),
        content: $.i18n.prop('component.loginRegister.noCountry'),
        button: $.i18n.prop('component.loginRegister.ok')
      });
      hasValid = false;
      return;
    }

    $('#register').addClass('disabled').text($.i18n.prop('component.loginRegister.submit'));
    params.currentPageUrl = window.location.href;
    params.prevPageUrl = document.referrer;
    (0, _ajax.default)({
      data: params,
      url: "".concat(ssoUrl, "/reg/user"),
      xhrFields: {
        'withCredentials': true
      },
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      type: 'POST',
      success: function success(res) {
        var userInfo = (0, _common.getBuryingPointInfo)();

        if (window && window.VSensors) {
          var data = {
            ip: userInfo.ip,
            account: $('#email').val(),
            country: countryValue,
            page_url: window.location.href,
            referrer: document.referrer,
            channel_code: userInfo.channelCode,
            register_method: "email",
            button: "sign up",
            hw_device: userInfo.hw_device
          };
          console.log("开始记录日志,数据为:" + JSON.stringify(data));
          window.vSensors.track('AIHOUSE_REGISTER', data);
        }

        $('#register').removeClass('disabled').text($.i18n.prop('component.loginRegister.signUp'));

        if (res && res.success) {
          showVerifyModal();
          gtag('event', 'select', {
            event_category: '页面-注册',
            event_label: '注册-成功'
          });
        } else {
          (0, _loginTipsModal.loginTipsModal)({
            title: $.i18n.prop('component.loginRegister.tips'),
            content: res.errorMessage,
            button: $.i18n.prop('component.loginRegister.ok')
          });
        }
      }
    });
  }
} // 注册-提交按钮


function onRegisterClick() {
  $('#register').click(function () {
    gtag('event', 'click', {
      event_category: '页面-注册',
      event_label: '注册按钮'
    });
    register();
  });
}

function handleToReg() {
  $('body').on('click', '.js-reg__link', function () {
    if (window && window.VSensors) {
      var userInfo = (0, _common.getBuryingPointInfo)();
      var data = {
        ip: userInfo.ip,
        page_url: window.location.href,
        referrer: document.referrer,
        channel_code: userInfo.channelCode,
        button: "sign up for log in",
        hw_device: userInfo.hw_device
      };
      console.log("开始记录日志,数据为:" + JSON.stringify(data));
      window.vSensors.track('AIHOUSE_REGISTER', data);
    }

    showRegisterModal('resetForm');
  });
}

function handleToLogin() {
  $('body').on('click', '.js-login__link', function () {
    if (window && window.VSensors) {
      var userInfo = (0, _common.getBuryingPointInfo)();
      var data = {
        ip: userInfo.ip,
        page_url: userInfo.pageUrl,
        referrer: userInfo.referrerUrl,
        channel_code: userInfo.channelCode,
        button: " log in for sign up",
        hw_device: userInfo.hw_device
      };
      console.log("开始记录日志,数据为:" + JSON.stringify(data));
      window.vSensors.track('AIHOUSE_LOGIN', data);
    }

    showLoginModal('resetForm');
  });
} // 注册-选择角色


function handleChooseRole() {
  $('body').on('click', '.chooseRole .page-block', function () {
    var isSelect = $(this).attr('selected');
    var role = $(this).attr('data-role');

    if (isSelect) {
      return;
    }

    chooseRole = Number(role) ? true : false;
    $(this).attr('selected', true).siblings('.page-block').removeAttr('selected');
    $(this).find('.icon-dagou').removeClass('hide');
    $(this).siblings().find('.icon-dagou').addClass('hide');
    $(this).addClass('active').siblings().removeClass('active');
    $('.js-chooseRole').removeClass('disabled');
  });
} // hover选择professional customer


function handleHoverType() {
  $('body').on('mouseenter', '#loginRegisterModal .page-block', function () {
    $(this).find('.img_type--hover').show();
    $(this).find('.img_type').hide();
  });
  $('body').on('mouseleave', '#loginRegisterModal .page-block', function () {
    $(this).find('.img_type--hover').hide();
    $(this).find('.img_type').show();
  });
} // 跳去


function toRegisterNext() {
  $('body').on('click', '.js-chooseRole', function () {
    showRegisterNextModal('resetForm');
  });
}

function handleToRetrieve() {
  $('body').on('click', '.js-retrieve__link', function () {
    showSetEmailModal('resetForm');
  });
} // 初始化sessison


function initSession() {
  (0, _ajax.default)({
    url: "".concat(ssoUrl, "/reg/init"),
    xhrFields: {
      'withCredentials': true
    },
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    success: function success(res) {}
  });
} // 验证码限制输入


function handleCodeIpt() {
  $('#retrieve_code').bind('input onpropertychange', function func() {
    var obj = this;
    var max = $(obj).attr('data-max');
    var pattern = /[^\w]/g; // 限制智能输入数字、字母

    obj.value = obj.value.replace(pattern, ''); // 限制输入位数

    if (obj.value.length > max) {
      obj.value = obj.value.slice(0, max);
    }
  });
} // 重新发送验证码邮件


function resendEmail() {
  (0, _ajax.default)({
    url: "".concat(ssoUrl, "/reg/verify/code/resend"),
    xhrFields: {
      'withCredentials': true
    },
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    success: function success(res) {
      if (res) {
        if (res.success) {
          (0, _loginTipsModal.loginTipsModal)({
            title: $.i18n.prop('component.loginRegister.tips'),
            content: $.i18n.prop('component.loginRegister.resendSucc'),
            button: $.i18n.prop('component.loginRegister.ok')
          });
        } else {
          (0, _loginTipsModal.loginTipsModal)({
            title: $.i18n.prop('component.loginRegister.tips'),
            content: res.errorMessage,
            button: $.i18n.prop('component.loginRegister.ok')
          });
        }
      }
    }
  });
} // 重新发送验证码


function onResendEmailClick() {
  $('body').on('click', '#resendEmail', function () {
    gtag('event', 'click', {
      event_category: '页面-验证码',
      event_label: '重新发送验证码邮件按钮'
    });
    resendEmail();
  });
}

function backTrack() {
  $('body').on('click', '#backTrack', function () {
    gtag('event', 'click', {
      event_category: '页面-验证码',
      event_label: '后退'
    });
    showRegisterModal();
  });
} // 初始化登录


function initLoginModal() {
  handleToRetrieve();
  handleToLogin();
  onAccountLoginClick();
  enterLogin();
  facebookLogin();
} // 初始化找回密码


function initRetrieveModal() {
  onSendEmailClick();
  handleRetrieveRadio();
  retrieveFormValid();
  sendMobile();
  validCode();
  validMyAndSingaporeMobile();
  submitResetPassord();
  handleMobileIpt();
  handleCodeIpt();
} // 初始化注册


function initRegisterModal() {
  handleChooseRole();
  toRegisterNext();
  handleToReg();
  onProvinceDropdownItemClick();
  onCountryDropdownItemClick();
  setRoleDropdownList();
  setCountryDropdownList();
  checkProtocolChecked();
  handleMobileIpt();
  onRegisterClick();
  onProtocolCheckboxClick();
  onProtocolLinkClick(); // setScrollbar();

  validPassword();
  validMyMobile();
  validSingapore();
  googleLogin();
  handleHoverType();
  handleInvitCode();
} // 监听邀请码输入


function handleInvitCode() {
  $('#ivtCode').bind('input onpropertychange', function () {// const obj = this;
    // const max = $(obj).attr('data-max');
    // if (obj.value.length > max) {
    //     obj.value = obj.value.slice(0, max);
    // }
  });
  $('#ivtCode').keypress(function (e) {
    var key = e.keyCode || e.which;
    key = String.fromCharCode(key);
    var regex = /[0-9]|\s|[a-z]|[A-Z]/;

    if (!regex.test(key)) {
      e.returnValue = false;

      if (e.preventDefault) {
        e.preventDefault();
      }
    }
  });
  /* eslint-disable */

  $('#ivtCode').keydown(function func(e) {
    var target = e.target;
    var max = $(this).attr('data-max');

    if (max != undefined && max != "") {
      var keyId = e.keyCode;
      var isDelete = false;

      switch (keyId) {
        case 8:
          isDelete = true;
          break;

        case 46:
          isDelete = true;
          break;

        default:
          break;
      }

      if (!isDelete && target.value.length === max) {
        return false;
      }
    }
  });
  /* eslint-disable */
  // 禁止输入中文

  $('#ivtCode').get(0).addEventListener('compositionstart', function (e) {
    tempStr = $('#ivtCode').val();
  }, false);
  $('#ivtCode').get(0).addEventListener('compositionend', function (e) {
    var reg = /[\u4e00-\u9fa5]/g;
    var str = e.data.replace(reg, '');
    $('#ivtCode').val(tempStr + str);
  }, false);
} // 初始化内容/字段展示


function initVerifyContentShow() {
  if ((0, _common.getCookie)('OPEN_ID')) {
    $('.loginRegister-modal .verify .page__title').text($.i18n.prop('component.loginRegister.associated_account'));
  } else {
    $('.loginRegister-modal .verify .page__title').text($.i18n.prop('component.loginRegister.signUp'));
  }

  var val = $('.register .reg__state .dropdown-item.active').attr('data-value'); // 马来注册文案描述

  if (val === 'Malaysia' || val === 'Singapore') {
    $('.verify .page__desc').text($.i18n.prop('component.loginRegister.verifyMobileDesc'));
  } else {
    $('.verify .page__desc').text($.i18n.prop('component.loginRegister.verify_desc'));
  }
} // 初始化发送验证码


function initVerifyModal() {
  onVerificationClick();
  onResendEmailClick();
  backTrack();
} // 监听发送邮件按钮点击


function onSendEmailClick() {
  $('body').on('click', '#sendEmail', function () {
    gtag('event', 'click', {
      event_category: '页面-找回密码',
      event_label: '发送身份验证邮件按钮'
    });
    sendEmail();
  });
} // 找回密码表单验证


function retrieveFormValid() {
  // 邮件表单
  retrieveFormValidate = $('#retrieveForm').validate({
    rules: {
      email: {
        required: true,
        email: true
      }
    },
    messages: {
      email: {
        required: $.i18n.prop('component.loginRegister.email_required'),
        email: $.i18n.prop('component.loginRegister.email_invalid')
      }
    }
  }); // 手机号码表单

  modifyPassFormValidate = $('#retrieveMobileForm').validate({
    rules: {
      mobile: {
        required: true,
        myAndSingaporeMobile: true
      },
      verifyCode: {
        required: true,
        codeSlphicCombinate: true
      },
      newPassword: {
        required: true,
        rangelength: [6, 20],
        slphicCombinate: true
      },
      confirmPassword: {
        required: true,
        equalTo: '#retrieve_password'
      }
    },
    message: {
      mobile: {
        required: $.i18n.prop('component.loginRegister.mobile_required'),
        myMobile: $.i18n.prop('component.loginRegister.mobile_my'),
        singaporeMobile: $.i18n.prop('component.loginRegister.mobile_singapore')
      },
      verifyCode: {
        required: $.i18n.prop('component.loginRegister.code_required'),
        codeSlphicCombinate: $.i18n.prop('component.loginRegister.mobile_code')
      },
      newPassword: {
        required: $.i18n.prop('component.loginRegister.password_tip'),
        rangelength: $.i18n.prop('component.loginRegister.password_tip'),
        slphicCombinate: $.i18n.prop('component.loginRegister.password_tip')
      },
      confirmPassword: {
        required: $.i18n.prop('component.loginRegister.password_required'),
        equalTo: $.i18n.prop('component.loginRegister.confirmPassword')
      }
    }
  });
} // 找回密码发送验证码方式切换


function handleRetrieveRadio() {
  $('.retrieve input:radio').click(function () {
    var val = $('.retrieve input:radio[name="receiveCodeOptions"]:checked').val();

    if (val === 'email') {
      $('#retrieveForm').show();
      $('#sendVerCode').text($.i18n.prop('component.loginRegister.send'));
      $('#retrieveMobileForm').hide().get(0).reset();
      modifyPassFormValidate && modifyPassFormValidate.resetForm();
    } else {
      $('#retrieveMobileForm').show();
      $('#retrieveForm').hide().get(0).reset();
      retrieveFormValidate && retrieveFormValidate.resetForm();
    }
  });
}

function setTime(obj) {
  timer = setInterval(function () {
    if (count === 0) {
      obj.removeClass('disabled');
      obj.text($.i18n.prop('component.loginRegister.resend'));
      count = 60; // 60秒过后button上的文字初始化,计时器初始化,清除定时器

      clearInterval(timer);
    } else {
      obj.addClass('disabled');
      obj.text("".concat(count, "s"));
      count--;
    }
  }, 1000);
} // 发送手机验证码


function sendMobile() {
  $('#sendVerCode').click(function () {
    var mobile = $('#retrieve_mobile').val();

    if (mobile) {
      (0, _ajax.default)({
        data: {
          mobile: mobile
        },
        url: "".concat(ssoUrl, "/password/retrieve/send/mobile"),
        type: 'POST',
        xhrFields: {
          'withCredentials': true
        },
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        success: function success(res) {
          if (res && res.success) {
            (0, _loginTipsModal.loginTipsModal)({
              title: $.i18n.prop('component.loginRegister.tips'),
              content: $.i18n.prop('component.loginRegister.code_suc'),
              button: $.i18n.prop('component.loginRegister.ok')
            });
            setTime($('#sendVerCode'));
          } else {
            (0, _loginTipsModal.loginTipsModal)({
              title: $.i18n.prop('component.loginRegister.tips'),
              content: res.errorMessage,
              button: $.i18n.prop('component.loginRegister.ok')
            });
            $('#sendVerCode').text($.i18n.prop('component.loginRegister.resend'));
          }
        }
      });
    }
  });
} // 发送邮件


function sendEmail() {
  if ($('#retrieveForm').valid()) {
    $('#sendEmail').addClass('disabled').text($.i18n.prop('component.loginRegister.sending'));
    (0, _ajax.default)({
      data: {
        email: $('#retrieve_email').val()
      },
      url: "".concat(ssoUrl, "/password/retrieve/send/email"),
      xhrFields: {
        'withCredentials': true
      },
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      success: function success(res) {
        $('#sendEmail').removeClass('disabled').text($.i18n.prop('component.loginRegister.send'));

        if (res && res.success) {
          (0, _loginTipsModal.loginTipsModal)({
            title: $.i18n.prop('component.loginRegister.tips'),
            content: $.i18n.prop('component.loginRegister.retrieve_suc'),
            button: $.i18n.prop('component.loginRegister.ok'),
            callback: function callback() {
              showLoginModal('resetForm');
            }
          });
        } else {
          (0, _loginTipsModal.loginTipsModal)({
            title: $.i18n.prop('component.loginRegister.tips'),
            content: res.errorMessage,
            button: $.i18n.prop('component.loginRegister.ok')
          });
        }
      }
    });
  }
} // 提交手机号码重置密码


function submitResetPassord() {
  $('body').on('click', '#submitChange', function () {
    if ($('#retrieveMobileForm').valid()) {
      $('#submitChange').addClass('disabled').text($.i18n.prop('component.loginRegister.submit'));
      (0, _ajax.default)({
        data: {
          mobile: $('#retrieve_mobile').val(),
          verificationCode: $('#retrieve_code').val(),
          password: $('#retrieve_password').val(),
          confirmPassword: $('#retrieve_confirmp').val()
        },
        url: "".concat(ssoUrl, "/password/change/mobile"),
        type: 'POST',
        xhrFields: {
          'withCredentials': true
        },
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        success: function success(res) {
          $('#submitChange').removeClass('disabled').text($.i18n.prop('component.loginRegister.submit1'));

          if (res && res.success) {
            (0, _loginTipsModal.loginTipsModal)({
              title: $.i18n.prop('component.loginRegister.tips'),
              content: $.i18n.prop('component.loginRegister.Modify_suc'),
              button: $.i18n.prop('component.loginRegister.ok'),
              callback: function callback() {
                showLoginModal('resetForm');
              }
            });
          } else {
            (0, _loginTipsModal.loginTipsModal)({
              title: $.i18n.prop('component.loginRegister.tips'),
              content: res.errorMessage,
              button: $.i18n.prop('component.loginRegister.ok')
            });
          }
        }
      });
    }
  });
} // 提交验证码


function verification() {
  gtag('event', 'click', {
    event_category: '页面-验证码',
    event_label: '验证码验证'
  });

  if ($('#verForm').valid()) {
    $('#verForm #verification').addClass('disabled').text($.i18n.prop('component.loginRegister.verifying'));
    (0, _ajax.default)({
      url: ssoUrl + "/reg/verify/".concat($('#code').val()),
      xhrFields: {
        'withCredentials': true
      },
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      success: function success(res) {
        var userInfo = (0, _common.getBuryingPointInfo)();

        if (window && window.VSensors) {
          var data = {
            ip: userInfo.ip,
            account: $('#email').val(),
            country: countryValue,
            is_success: res && res.success,
            page_url: window.location.href,
            referrer: document.referrer,
            channel_code: userInfo.channelCode,
            register_method: "email",
            button: "verification",
            hw_device: userInfo.hw_device
          };
          console.log("开始记录日志,数据为:" + JSON.stringify(data));
          window.vSensors.track('AIHOUSE_REGISTER', data);
        }

        $('#verForm #verification').removeClass('disabled').text($.i18n.prop('component.loginRegister.verification'));

        if (res && res.success) {
          var gclid = (0, _common.getCookie)('gclid'); // const gclid = sessionStorage.getItem('gclid');
          //window.location.href = '/signUp/success';
          // if (gclid) {
          //   window.location.href = '/signUp/success';
          // } else {
          //   window.location.reload();
          // }

          var href = res.result; //从后端返回包装了写3vjia域名的路径，把回跳地址更换为成功页面

          var callbackurl = href.match("(?<=callbackurl=).*?(?=&|$)");

          if (callbackurl) {
            href = href.replace(callbackurl[0], location.origin + '/signUp/success');
          }

          window.location.href = href;
        } else {
          (0, _loginTipsModal.loginTipsModal)({
            title: $.i18n.prop('component.loginRegister.tips'),
            content: res.errorMessage,
            button: $.i18n.prop('component.loginRegister.ok')
          });
        }
      }
    });
  }
}

function onVerificationClick() {
  $('body').on('click', '#verification', function () {
    gtag('event', 'click', {
      event_category: '页面-验证码',
      event_label: '提交验证码按钮'
    });
    verification();
  });
} // 设置滚动条


function setScrollbar() {
  $('.loginRegister-modal .dropdown-menu').mCustomScrollbar({
    theme: 'minimal-dark',
    scrollInertia: 200,
    scrollEasing: 'linear',
    setWidth: '100%'
  });
} // facebook点击监听


function facebookLogin() {
  $('body').on('click', '.js-btn__facebook', function () {
    //const ssoUrl = $('#sso').val();
    gtag('event', 'click', {
      event_category: '页面-登录',
      event_label: 'Facebook登录按钮'
    });
    var userInfo = (0, _common.getBuryingPointInfo)(); //神策埋点

    if (window && window.VSensors) {
      var data = {
        organ_type: "零售",
        ip: userInfo.ip,
        page_url: window.location.href,
        referrer: document.referrer,
        channel_code: userInfo.channelCode,
        hw_login_method: "facebook",
        hw_device: userInfo.hw_device
      };
      console.log("开始记录日志,数据为:" + JSON.stringify(data));
      window.vSensors.track('AIHOUSE_LOGIN', data);
    }

    FB.login(function (response) {
      if (response.status === 'connected') {
        window.location.href = ssoLoginUrl + "/verify/facebook/code";
      }
    }, {
      scope: 'public_profile,email'
    });
  });
} // google点击监听


function googleLogin() {
  $('body').on('click', '.js-btn__google', function () {
    gtag('event', 'click', {
      event_category: '页面-登录',
      event_label: 'Google登录按钮'
    });
    var userInfo = (0, _common.getBuryingPointInfo)(); //神策埋点

    if (window && window.VSensors) {
      var data = {
        organ_type: "零售",
        ip: userInfo.ip,
        page_url: window.location.href,
        referrer: document.referrer,
        channel_code: userInfo.channelCode,
        hw_login_method: "google",
        hw_device: userInfo.hw_device
      };
      console.log("开始记录日志,数据为:" + JSON.stringify(data));
      window.vSensors.track('AIHOUSE_LOGIN', data);
    }

    window.auth2.grantOfflineAccess().then(googleLoginCallBack);
  });
} // google登录回调


function googleLoginCallBack(authResult) {
  if (authResult['code']) {
    $('#signinButton').attr('style', 'display: none');
    var secDomain = window.location.href.split('.')[0].split('//')[1];
    $.ajax({
      type: 'GET',
      url: ssoLoginUrl + '/validate/google?redirect=' + secDomain,
      xhrFields: {
        'withCredentials': true
      },
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      contentType: 'application/octet-stream; charset=utf-8',
      success: function success(result) {
        (0, _common.setCookie)('exResult', result.exResult);
        (0, _common.setCookie)('exResultFlag', result.exResultFlag);
        var href = result.result; //从后端返回包装了写3vjia域名的路径，把回跳地址更换为成功页面

        window.location.href = href; //window.location.reload();
      },
      data: {
        'code': authResult['code']
      }
    });
  }
} // google sdk 初始化


function initGoogle() {
  console.log('init Google');

  (function (d, s, id) {
    var js,
        fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s);
    js.id = id;
    js.src = "//apis.google.com/js/client:platform.js?onload=start";
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'google-jssdk');

  window.start = function () {
    var googleClientId = $('#google-client-id').val();
    gapi.load('auth2', function () {
      console.log('auth2');
      window.auth2 = gapi.auth2.init({
        client_id: googleClientId
      });
    });
  };
} // 弹出登录框


function showLoginModal(type) {
  if (type === 'resetForm' && loginFormValidate) {
    $('#account').val('');
    $('#password').val('');
    loginFormValidate.resetForm();
  }

  initLoginContentShow();
  loginFormValid();
  (0, _common.initFaceBook)();
  initGoogle();
  $('#loginRegisterModal').modal('show');
  $('.loginRegister-modal .base-content').hide();
  $('.loginRegister-modal .base-content.login').show();
} // 弹出注册框-选择角色


function showRegisterModal(type) {
  showRegisterNextModal('resetForm');
} // 弹出注册框-表单输入


function showRegisterNextModal(type) {
  $('#email').val('');
  $('#regPassword').val('');
  $('#username').val('');
  $('#mobile').val('');
  $('#role').val('');
  $('#protocol').attr('checked', false);
  $('#protocolCheckbox').removeClass('invalid');
  var flag = false; // 标记是否选中国家

  $('.reg__state .dropdown-menu .dropdown-item').each(function (index, item) {
    if (urlMatch && urlMatch[1] === $(item).attr('data-site')) {
      flag = true;
      $('#state').val($(item).attr('data-value'));
      countryValue = $(item).attr('data-value');
      $(item).addClass('active');
      $(item).siblings('.active').removeClass('active');
    }
  });

  if (!flag) {
    $('#state').val('');
  } //registerFormValidate.resetForm();


  hasValid = false; // 重置国家列表

  $('.loginRegister-modal .reg__state .dropdown-menu .mCSB_container').html(fullCountryListHTML);
  initRegisterContentShow();
  registerFormValid();
  initSession();
  initProvinceDropdown();
  $('#loginRegisterModal').modal('show');
  $('.loginRegister-modal .base-content').hide();
  $('.loginRegister-modal .base-content.register').show();
  $('.reg-password__previous').show(); // 第一次弹出窗口，选择马来国家，再关闭弹窗，手机校验规则依旧是马来手机号，要移除

  $('#regForm #mobile').rules().myMobile && $('#regForm #mobile').rules('remove', 'myMobile');
  $('#regForm #mobile').rules().singaporeMobile && $('#regForm #mobile').rules('remove', 'singaporeMobile');
  $('#mobile').prop('placeholder', $.i18n.prop('component.loginRegister.mobile_placeholder'));
  $('#regForm').validate().settings.messages.mobile.required = $.i18n.prop('component.loginRegister.mobile_tip1'); // 马来站点配置校验规则

  if (urlMatch[1] === 'my') {
    var dom = $('#regForm #mobile');
    $(dom).rules().myMobile || $(dom).rules('add', {
      myMobile: true
    });
    $(dom).rules().rangelength && $(dom).rules('remove', 'rangelength'); // 更改required校验的文案并进行校验

    $('#regForm').validate().settings.messages.mobile.required = $.i18n.prop('component.loginRegister.mobile_tip');
    $('#regForm').validate().element($('#mobile'));
  }

  $('.loginRegister-modal .reg__role').show();
} // 弹出发送邮件框（忘记密码框）


function showSetEmailModal(type) {
  var href = window.location.href.split('.aihouse.com')[0]; // 是马来站点，显示单选框

  if (href.indexOf('my') > -1) {
    $('#retrieveRadioForm').show(); // 重置单选框

    $('#retrieveRadioForm').get(0).reset();
  } else {
    $('#retrieveRadioForm').hide();
  }

  if (type === 'resetForm') {
    console.log('reset');
    $('#retrieveMobileForm').get(0).reset();
    modifyPassFormValidate && modifyPassFormValidate.resetForm();
    $('#retrieveForm').get(0).reset();
    retrieveFormValidate && retrieveFormValidate.resetForm(); // 移除上一次的倒计时

    timer && clearInterval(timer);
    $('#sendVerCode').text($.i18n.prop('component.loginRegister.send')).removeClass('disabled');
  }

  $('#loginRegisterModal').modal('show');
  $('.loginRegister-modal .base-content').hide();
  $('.loginRegister-modal .base-content.retrieve').show();
  $('.loginRegister-modal .base-content.retrieve #retrieveForm').show();
  $('.loginRegister-modal .base-content.retrieve #retrieveMobileForm').hide();
} // 弹出发送验证码框


function showVerifyModal() {
  initVerifyContentShow();
  verifyFormValid();
  $('#loginRegisterModal').modal('show');
  $('.loginRegister-modal .base-content').hide();
  $('.loginRegister-modal .base-content.verify').show();
} // 判断是否url是否带有邀请参数，默认打开注册框


function handleInvitedRegister() {
  var urlObj = (0, _common.parseUrl)(window.location.href);
  var isLogin = $('.js-isLogin').attr('data-islogin');
  console.log('urlObj', urlObj); // 存在邀请码

  if (urlObj.ivtCode && !isLogin) {
    $('#ivtCode').val(urlObj.ivtCode); // 添加邀请码动态disabled,用于恢复校验

    $('body').on('mouseenter', '#ivtCode', function () {
      $('#ivtCode').attr('disabled', true);
    });
    $('body').on('mouseleave', '#ivtCode', function () {
      $('#ivtCode').removeAttr('disabled');
    });

    if ((0, _common.isMobileDevice)()) {
      // 跳转至单点登录
      //const ssoUrl = $('#sso').val();
      window.location.href = "".concat(ssoUrl, "/reg?ivtCode=").concat(urlObj.ivtCode);
    } else {
      // PC弹出注册框
      showRegisterModal();
    }
  }
}

function initLoginRegister() {
  initLoginModal();
  initRegisterModal();
  initRetrieveModal();
  initVerifyModal();
  setScrollbar();
}

},{"../assert/country/country.json":1,"../assert/country/province":2,"../common/js/ajax":3,"../common/js/common":4,"./loginTipsModal":9}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginTipsModal = loginTipsModal;
exports.closeTipsModal = closeTipsModal;
var tipsModalCallback;
var type;
/**
 * 提示弹窗。用于登录注册弹窗，联系我们弹窗，联系我们页
 * @param title：标题文案
 * @param content：内容文案
 * @param button：按钮文案
 * @param callback：回调函数
 * @param fnType：类型（initModal：页面使用，避免样式问题）
 */

function loginTipsModal(_ref, fnType) {
  var title = _ref.title,
      content = _ref.content,
      button = _ref.button,
      _ref$callback = _ref.callback,
      callback = _ref$callback === void 0 ? function func() {} : _ref$callback;
  $('#loginTipsModal').modal('show');
  $('#loginTipsModal .modal-title').text(title);
  $('#loginTipsModal .modal-body').text(content);
  $('#loginTipsModal .modal-footer button').text(button);
  tipsModalCallback = callback;
  type = fnType; // 移除上一次弹框事件 登录注册弹窗重置密码，邮件发送成功后返回登录界面

  $('.base-layout').off('click', '.loginTips-modal__button');
  $('.base-layout').on('click', '.loginTips-modal__button', function () {
    $('#loginTipsModal').modal('hide');
    callback();
  });

  if (type === 'initModal') {
    $('body').removeClass('modal-open');
    $('body').css({
      'padding-right': 0
    });
    $('.base-header__country.fixed-top').css({
      'padding-right': 0
    });
    $('.base-header__nav.fixed-top').css({
      'padding-right': 0
    });
  }
} // 关闭提示弹窗


function closeTipsModal() {
  $('#loginTipsModal').modal('hide');
  $('body').addClass('modal-open').css({
    'padding-right': '17px'
  });
  tipsModalCallback();
}

$('.tips-modal__button').click(function () {
  tipsModalCallback();
});
$('#loginTipsModal').on('hidden.bs.modal', function () {
  // 执行一些动作...
  if (type !== 'initModal') {
    $('body').addClass('modal-open').css({
      'padding-right': '17px'
    });
  } else {
    $('body').removeClass('modal-open').css({
      'padding-right': '0'
    });
  }
});

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.graphModal = graphModal;
exports.graphModalOnlyUrl = graphModalOnlyUrl;

/*
* 注册登录弹窗
* @pagram btn 触发打开弹窗的按钮ID
* @pagram iframeUrl 打开的iframe地址
*/
function graphModal(btn, iframeUrl) {
  var modal = document.getElementById("JgraphModal");
  if (!modal) return;
  var triggerBtn = typeof btn === 'string' ? document.getElementById(btn) : btn;
  $(triggerBtn).click(function () {
    $(modal).find('iframe').attr('src', iframeUrl || '/graph/login');
    $(modal).modal('show');
  });

  document.getElementById("JgraphModalClose").onclick = function () {
    $(modal).find('iframe').attr('src', '');
  };
}
/*
* 注册登录弹窗
* @pagram iframeUrl 打开的iframe地址
*/


function graphModalOnlyUrl(iframeUrl) {
  var modal = document.getElementById("JgraphModal");
  if (!modal) return;
  $(modal).find('iframe').attr('src', iframeUrl || '/graph');
  $(modal).modal('show');

  document.getElementById("JgraphModalClose").onclick = function () {
    $(modal).find('iframe').attr('src', '');
  };
} // 监听接收消息


if (!$(window).data('message')) {
  window.addEventListener('message', function (event) {
    var _event$data = event.data,
        data = _event$data.data,
        key = _event$data.key;

    if (key === 'set_graph_modal_close') {
      document.getElementById("JgraphModalClose").click();
    }
  });
}

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSchemeSwiper = initSchemeSwiper;
exports.onSchemeSwiperItemClick = onSchemeSwiperItemClick;
exports.onNewsSwiperItemClick = onNewsSwiperItemClick;

var _common = require("../common/js/common");

var isMobile = (0, _common.isMobileDevice)(); // 初始化方案轮播图

function initSchemeSwiper() {
  function initScheme(name) {
    var domLenth = $("".concat(name, " .swiper-wrapper li")).length; // eslint-disable-next-line no-unused-vars

    var schemeSwiper; // eslint-disable-next-line

    if (domLenth > 1) {
      $('.scheme-swiper__navigation').show();
      schemeSwiper = new Swiper(name, {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        loop: true,
        lazy: {
          loadPrevNext: true,
          loadOnTransitionStart: true
        },
        pagination: {
          el: "".concat(name, " .swiper-pagination"),
          clickable: true
        },
        navigation: {
          nextEl: "".concat(name, " .swiper-button-next"),
          prevEl: "".concat(name, " .swiper-button-prev")
        }
      });
    } else {
      schemeSwiper = new Swiper(name, {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        loop: false,
        noSwiping: true,
        lazy: {
          loadPrevNext: true,
          loadOnTransitionStart: true
        }
      });
      $("".concat(name, " .scheme-swiper__navigation-wrapper")).css('display', 'none');
    }
  }

  if (isMobile) {
    initScheme('#m-schemeSwiper');
  } else {
    initScheme('#schemeSwiper');
  }
}

function onSchemeSwiperItemClick() {
  function initSchemeSwiperItemClick(name) {
    $("".concat(name, " .swiper-slide")).click(function func() {
      (0, _common.jumpPage)("/scheme/detail/".concat($(this).data('id')));
    });
  }

  if (isMobile) {
    initSchemeSwiperItemClick('#m-schemeSwiper');
  } else {
    initSchemeSwiperItemClick('#schemeSwiper');
  }
}

function onNewsSwiperItemClick() {
  function initNewsSwiperItemClick(name) {
    $("".concat(name, " .swiper-slide")).click(function func() {
      var url = $(this).attr('data-attachUrl');

      if (url) {
        (0, _common.jumpPage)("".concat(url), true);
      }
    });
  }

  if (isMobile) {
    initNewsSwiperItemClick('#m-schemeSwiper');
  } else {
    initNewsSwiperItemClick('#schemeSwiper');
  }
}

},{"../common/js/common":4}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = showToastModal;

function showToastModal(_ref) {
  var iconClass = _ref.iconClass,
      content = _ref.content,
      description = _ref.description;
  $('#toastModal-content').text(content);
  $('#toastModal-icon').removeClass().addClass(iconClass).addClass('iconfont');

  if (description) {
    $('#toastModal').addClass('toast-modal--dec');
    $('#toastModal-desc').text(description).show();
  } else {
    $('#toastModal-desc').hide();
  }

  $('#toastModal').modal({
    show: true,
    backdrop: false
  }); // 自动关闭弹窗

  setTimeout(function () {
    $('#toastModal').modal('hide');
  }, 2000);
}

},{}],13:[function(require,module,exports){
"use strict";

var _homeSwiper = require("../../components/homeSwiper");

var _designerItem = require("../../components/designgallery/designerItem");

var _schemeItem = require("../../components/designgallery/schemeItem");

var _schemeSwiper = require("../../components/schemeSwiper");

var _common = require("../../common/js/common");

var _ajax = _interopRequireDefault(require("../../common/js/ajax"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import onFloatButtonClick from '../../components/floatButton';
var isMobile = (0, _common.isMobileDevice)();
var queryParam = {
  pageIndex: 1,
  pageSize: 15,
  pageAccount: 0,
  st: '',
  // style
  rt: '',
  // room
  ht: '',
  // layout
  a: '',
  // area
  sort: '' // 排序： 0：推荐 1：最新 2：最热

};
var isLoading = false;
var imgUrl = $('#imgUrl').val(); // 设计师列表切换

function changeDesignerList() {
  $('.designer-menu__item').click(function () {
    if ($(this).hasClass('active')) {
      return;
    }

    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    var type = $(this).attr('data-type');
    var dom = $(this).parents('.designer').find(".row[data-type=".concat(type, "]"));
    $(dom).siblings('.row').addClass('hidden');
    $(dom).removeClass('hidden');
    bLazy.revalidate();
  });
} // 移动端-请求列表数据


function fetchMDesignList(callback) {
  if (!isMobile) {
    return;
  } // 加载中


  if (isLoading) {
    return;
  }

  isLoading = true;
  var queryParamss = JSON.parse(JSON.stringify(queryParam));
  delete queryParamss.pageAccount;
  $('.design-loading').show();
  $('.design-noData').hide();
  (0, _ajax.default)({
    url: '/designScheme/getList',
    type: 'GET',
    data: queryParamss,
    success: function success(res) {
      isLoading = false;
      queryParam.pageAccount = res.recordCount;
      $('.design-loading').hide();
      var html = '';
      $('.js-design-account').text(res.recordCount); // 没有数据，缺省图显示

      if (res.recordCount === 0) {
        $('.design-noData').show();
      } else {
        $('.design-noData').hide();
      }

      if (res.result) {
        res.result.forEach(function (item) {
          if (item.schemeImage.indexOf('?') > -1) {
            // eslint-disable-next-line no-param-reassign
            item.schemeImage += '&x-oss-process=image/resize,m_fill,w_750';
          } else {
            // eslint-disable-next-line no-param-reassign
            item.schemeImage += '?x-oss-process=image/resize,m_fill,w_750';
          }

          if (item.authorImage) {
            // eslint-disable-next-line no-param-reassign
            item.authorImage = imgUrl + item.authorImage;
          } else {
            // eslint-disable-next-line no-param-reassign
            item.authorLogo = imgUrl + item.authorLogo;
          }

          html += template('schemeItem', {
            item: item
          });
        });
        $('.js-design-listWpt').append(html);
        bLazy.revalidate();
      } // eslint-disable-next-line no-unused-expressions


      callback && callback();
    }
  });
} // 移动端-监听筛选是否confirm


function handleCanConfirm() {
  var idx = 0;
  var domList = $('.filter-model .js-type__block');
  domList.each(function (index, item) {
    var isActive = $(item).hasClass('active');

    if (isActive) {
      $('.js-filter__reset').addClass('active');
      $('.js-filter__confirm').addClass('active');
    } else {
      idx += 1;
    }

    if (idx === domList.length) {
      $('.js-filter__reset').removeClass('active');
      $('.js-filter__confirm').removeClass('active');
    }
  });
} // 隐藏filter model


function closeFilterModel() {
  $('.filter-model').removeClass('show');
  (0, _common.hideMask)();
} // 隐藏sort model


function closeSortModel() {
  $('.sort-model').removeClass('show');
  (0, _common.hideMask)();
} // 生成筛选标签显示


function createFilterTag(domList) {
  var html = '';
  domList.each(function (index, item) {
    var id = $(item).attr('data-id');
    var name = $(item).text();
    html += "<div class=\"design-filters__item\" data-id=\"".concat(id, "\">\n              <span class=\"design-filters__name\">").concat(name, "</span>\n              <i class=\"iconfont icon-guanbibiaoqian\"></i>\n            </div>");
    $('.js-design-filters').html(html);
  });

  if (domList.length === 0) {
    $('.js-design-filters').empty();
  }
} // 重置筛选条件


function resetFilter() {
  queryParam.pageIndex = 1;
  queryParam.pageAccount = 0;
  queryParam.st = '';
  queryParam.rt = '';
  queryParam.a = '';
  queryParam.ht = '';
} // 取出筛选值


function getFilterVal() {
  resetFilter();
  var queryObj = {};
  var selectedDom = $('.filter-model').find('.js-type__block.active');
  selectedDom.each(function (index, item) {
    var key = $(item).parents('.filter-list__item').attr('data-type');
    var val = $(item).attr('data-id');
    queryObj[key] = val;
  });
  queryParam = Object.assign(queryParam, queryObj);
} // 监听筛选标签删除


function handleMoveFilterTag() {
  $('.js-design-filters').on('click', '.design-filters__item', function () {
    var id = $(this).attr('data-id');
    $('.filter-model .js-type__block').each(function (index, item) {
      var itemId = $(item).attr('data-id');

      if (id === itemId) {
        $(item).removeClass('active');
      }
    });
    $(this).remove();
    getFilterVal();
    $('.js-design-listWpt').empty();
    fetchMDesignList();
    handleCanConfirm();
  });
} // 移动端-监听筛选项点击,展开


function handleFilterOperate() {
  $('.base-layout').on('click', '.js-filter__toogle', function () {
    $(this).parents('.filter-list__item').find('.filter-item__type').toggleClass('hidden');
    $(this).parents('.filter-list__item').toggleClass('unfold');
  });
  $('.base-layout').on('click', '.js-type__block', function () {
    console.log('is click');
    $(this).toggleClass('active').siblings().removeClass('active');
    handleCanConfirm();
  });
  $('.base-layout').on('click', '.js-filter__reset', function () {
    $('.filter-model').find('.type-block.active').removeClass('active');
    var selectedDom = $('.filter-model').find('.js-type__block.active');
    resetFilter();
    createFilterTag(selectedDom);
    getFilterVal();
    $('.js-design-listWpt').empty();
    fetchMDesignList();
    closeFilterModel();
    $('.fixed-btn__reset').removeClass('active');
    $('.js-filter__confirm').removeClass('active'); // handleCanConfirm();
  });
  $('.base-layout').on('click', '.js-filter__confirm', function () {
    var selectedDom = $('.filter-model').find('.js-type__block.active');
    resetFilter();
    createFilterTag(selectedDom);
    getFilterVal();
    $('.js-design-listWpt').empty();
    fetchMDesignList();
    closeFilterModel();
  });
  $('.base-layout').on('click', '.js-filterModel-close', function () {
    closeFilterModel();
  });
} // 打开filter model


function openFilterModel() {
  $('.filters-btn__filter').click(function () {
    (0, _common.showMask)({
      color: 'rgba(0,0,0,.45)',
      fixed: true
    }, function () {
      closeFilterModel();
    });
    $('.filter-model').show();
    $('.filter-model').addClass('show');
  });
} // 打开排序 model


function openSortModel() {
  $('.filters-btn__type').click(function () {
    (0, _common.showMask)({
      color: 'rgba(0,0,0,.45)',
      fixed: true
    }, function () {
      closeSortModel();
    });
    $('.sort-model').show();
    $('.sort-model').addClass('show');
  });
} // 监听排序操作点击


function handleSortClick() {
  $('.base-layout').on('click', '.sort-model .js-sort__btn', function () {
    var type = $(this).attr('data-type');
    var text = $(this).text().trim(); // 筛选操作

    if (type) {
      // resetFilter();
      queryParam.pageIndex = 1;
      queryParam.sort = type;
      $('.js-design-listWpt').empty();
      $('.m-design-filter .js-sort__text').text(text);
      fetchMDesignList();
    }

    closeSortModel();
  });
} // 滚动监听


function winScroll() {
  // queryParam.pageIndex += 1;
  // $(window).scroll(throttle(fetchMDesignList), 100, 100);
  (0, _common.handleWinScroll)('.js-design-listWpt .scheme-item:last', function () {
    var _queryParam = queryParam,
        pageIndex = _queryParam.pageIndex,
        pageAccount = _queryParam.pageAccount,
        pageSize = _queryParam.pageSize;

    if (pageIndex * pageSize < pageAccount && isLoading === false) {
      queryParam.pageIndex += 1;
      fetchMDesignList();
    }
  });
} // 滚动监听，筛选项置顶


function handleFilterFixed() {
  $(window).scroll((0, _common.throttle)(function () {
    var scrollTop = $(document).scrollTop();
    var height1 = $('.base-header__nav').height();
    var height2 = $('#m-schemeSwiper').height();

    if (scrollTop >= height1 + height2) {
      $('.js-design-filters').addClass('fixed');
    } else {
      $('.js-design-filters').removeClass('fixed');
    }
  }, 100, 100));
} // 移动端初始化


function initMobile() {
  if (isMobile) {
    // onFloatButtonClick();
    fetchMDesignList(winScroll);
    handleFilterOperate();
    openFilterModel();
    handleFilterFixed();
    handleMoveFilterTag();
    openSortModel();
    (0, _schemeSwiper.initSchemeSwiper)();
    (0, _schemeSwiper.initSchemeSwiper)();
    handleSortClick();
    (0, _designerItem.handleDesignerLink)();
    (0, _schemeItem.handleSchemeLink)();
  }
} // PC端初始化


function initPc() {
  if (!isMobile) {
    // onFloatButtonClick();
    (0, _homeSwiper.initHomeSwiper)();
    changeDesignerList();
    (0, _designerItem.handleDesignerLink)();
    (0, _schemeItem.handleSchemeLink)();
  }
}

$(function () {
  initMobile();
  initPc();
});

},{"../../common/js/ajax":3,"../../common/js/common":4,"../../components/designgallery/designerItem":5,"../../components/designgallery/schemeItem":6,"../../components/homeSwiper":7,"../../components/schemeSwiper":11}]},{},[13]);
